<p-toast></p-toast>
<div *ngIf="applicationDetails?.APP_ID">
  <div class="col-12">
    <div class="card form-heading" reflow="true">
      <h5>{{'FARMER_APPLICATION_DETAILS' | translate}}</h5>
    </div>
    <div class="card hidden-xs to-print" id="printableArea" reflow="true">
      <div class="consent-form border">
        <!-- <div [align]="'right'" class="print border bold" style="margin-top: 0px ;" >Print Form</div> -->
        <div class="header border p-fluid p-formgrid justify-content-center top-header" style="display: flex; flex-wrap:wrap">
          <div class="field md:col-3 col-12">
            <!-- src="https://primefaces.org/cdn/primeng/images/galleria/galleria10.jpg"  -->
            <p-image *ngIf="applicationDetails?.FarmerPersonalData?.FdQRCodePath"
              [src]="applicationDetails?.FarmerPersonalData?.FdQRCodePath" alt="Image" width="150"
              height="150px" iconPos="left" [preview]="true"></p-image>
          </div>
          <div class="field md:col-6 col-12 top-header-text">
            <p class="header-val">{{'FARMER_APPLICATION_FORM_FOR_MICRO_IRRIGATION_SCHEME' | translate}}</p>
            <p class="header-date">{{'REG_DATE' | translate}} : {{ applicationDetails?.RegDate | date: "mediumDate" }}</p>
          </div>
          <div class="field md:col-3 col-12">
            <!-- <p-image *ngIf="applicationDetails?.FarmerPersonalData?.Farmer_Photo"
              src="applicationDetails?.FarmerPersonalData?.Farmer_Photo" 
              alt="Image" 
              width="150" 
              [preview]="true"></p-image> -->
            <!-- <p *ngIf="applicationDetails?.FarmerPersonalData?.Farmer_Photo">
              <a style="cursor: pointer" [href]="applicationDetails?.FarmerPersonalData?.Farmer_Photo"
                target="_blank">{{'VIEW_FARMER_PHOTO' | translate}}</a>
            </p> -->
            <p-image *ngIf="applicationDetails?.FarmerPersonalData?.Farmer_Photo"
              [src]="applicationDetails?.FarmerPersonalData?.Farmer_Photo" alt="Image" width="150"
              height="150px" iconPos="left" [preview]="true"></p-image>
          </div>
        </div>
        <div class="p-fluid p-formgrid grid kyc-status-details">
          <div class="field col-12 md:col-6 kyc-block">
            <label>{{'KYC_STATUS'| translate}}: <label [style]="{'color': (applicationDetails?.FarmerPersonalData?.IsAadharVerified == 1) ? 'rgb(2, 128, 2)' : 'rgb(240, 3, 3)'}">{{ applicationDetails.FarmerPersonalData.IsAadharVerified == 1 ? 'Verified': 'Not Verified' }}</label></label>
          </div>
    
          <div class="field col-12 md:col-6">
            <label>{{'REFERENCE_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ applicationDetails.FarmerPersonalData.TxnId }}</label></label>
          </div>
        </div>
        <div class="sub-header">
          <table class="border">
            <tr>
              <td>
                <p class="head">{{'APPLICATION_NO' | translate}}</p>
                <p class="bold">{{ applicationDetails.APP_ID }}</p>
              </td>
              <td>
                <p class="head">{{'FINANCIAL_YEAR' | translate}}</p>
                <p class="bold">{{ applicationDetails?.FincialYear }}</p>
              </td>
              <td>
                <p class="head">{{'SCHEME_NAME' | translate}}</p>
                <p class="bold">
                  {{ applicationDetails.Scheme_Code == 'Pond' ? 'Tank' : applicationDetails.Scheme_Code }}
                </p>
              </td>
            </tr>
          </table>
        </div>

        <!-- personal details start -->
        <ng-container *ngIf="applicationDetails.FarmerPersonalData">
          <div class="print border bold sec-heading-subsidy-details">{{'PERSONAL_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <td>
                  <p class="bold">{{'FARMER_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Name }}</p>
                </td>
                <td>
                  <p class="bold">{{'FATHER_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Father_name }}</p>
                </td>
                <td>
                  <p class="bold">{{'MOTHER_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Mother_Name }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'SEX' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Gender }}</p>
                </td>
                <td>
                  <p class="bold">{{'DATE_OF_BIRTH' | translate}}</p>
                  <p>
                    {{
                    applicationDetails.FarmerPersonalData.DOB
                    | date: "mediumDate"
                    }}
                  </p>
                </td>
                <td>
                  <p class="bold">{{'MOBILE' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Mobile }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'EMAIL' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Email_ID }}</p>
                </td>
                <td>
                  <p class="bold">{{'AADHAR_NO' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Aadhar_No }}</p>
                  <div *ngIf="!viewLinkMasked" class="hidden-print">
                    <a style="cursor: pointer" [href]="
                        applicationDetails?.FarmerPersonalData
                          ?.Aadhaar_Copy_Upload
                      " target="_blank">{{'VIEW_DOC' | translate}}</a>
                  </div>
                </td>
                <td>
                  <p class="bold">{{'VILLAGE' | translate}}</p>
                  <p>
                    {{ applicationDetails.FarmerPersonalData.Village_Code }}
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'BLOCK' | translate}}</p>
                  <p>
                    {{ applicationDetails.FarmerPersonalData.Block }}
                  </p>
                </td>
                <td>
                  <p class="bold">{{'DISTRICT' | translate}}</p>
                  <p>
                    {{ applicationDetails.FarmerPersonalData.District }}
                  </p>
                </td>
                <td>
                  <p class="bold">{{'CASTE' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Caste_Code }}</p>
                  <div class="hidden-print" *ngIf="applicationDetails?.FarmerPersonalData
                          ?.casteCertificate_Uploaded">
                    <a style="cursor: pointer" [href]="
                        applicationDetails?.FarmerPersonalData
                          ?.casteCertificate_Uploaded
                      " target="_blank">{{'VIEW_DOC' | translate}}</a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'ADDRESS' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Address }}</p>
                </td>
                <td>
                  <p class="bold">{{'PINCODE' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.Pin_Code }}</p>
                </td>
                <td>
                  <p class="bold">{{'PPP_ID' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.PPP_ID }}</p>
                  <div *ngIf="!viewLinkMasked" class="hidden-print">
                    <a style="cursor: pointer" [href]="
                        applicationDetails?.FarmerPersonalData
                          ?.ID_Proof_FilePath
                      " target="_blank">
                      <p>{{'VIEW_DOC' | translate}}</p>
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'MFMB_NO' | translate}}</p>
                  <p>{{ applicationDetails.FarmerPersonalData.MFMBNo }}</p>
                </td>
                <td>
                  <p class="bold">{{'APPLICATION_TYPE' | translate}}</p>
                  <p>{{ applicationDetails?.ApplicantType }}</p>
                </td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- personal details end -->


        <!-- member details -->
        <ng-container *ngIf="
            applicationDetails.Group_Datas &&
            applicationDetails.Group_Datas.length > 0
          ">
          <div class="print border bold sec-heading-subsidy-details">{{'MEMBER_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'MEMBER_NO' | translate}}</th>
                <th>{{'APP_ID' | translate}}</th>
                <th>{{'NAME' | translate}}</th>
                <th>{{'FATHER_NAME' | translate}}</th>
                <th>{{'MOTHER_NAME' | translate}}</th>
                <th>{{'GENDER' | translate}}</th>
                <th>{{'DATE_OF_BIRTH' | translate}}</th>
                <th>{{'CASTE' | translate}}</th>
                <th>{{'ADDRESS' | translate}}</th>
                <th>{{'PPP_ID' | translate}}</th>
                <th>{{'ID_PROOF_FILE_PATH' | translate}}</th>
                <th>{{'AADHAR_COPY' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.Group_Datas">
                <td>{{ item.memberID }}</td>
                <td class="clickable" (click)="onClickApp(item.AppId)">{{ item.AppId }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ item.Father_name }}</td>
                <td>{{ item.Mother_Name }}</td>
                <td>{{ item.Gender }}</td>
                <td>{{ item.DOB }}</td>
                <td>{{ item.Caste_Code }}</td>
                <td>{{ item.Address }}</td>
                <td>{{ item.PPP_ID }}</td>
                <td><a [href]="item?.ID_Proof_FilePath" target="_blank">{{'VIEW_ID_PROOF' | translate}}</a></td>
                <td><a [href]="item?.Aadhaar_Copy_Upload" target="_blank">{{'VIEW_AADHAR_COPY' | translate}}</a></td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- member details end -->

        <!-- land details -->
        <ng-container *ngIf="
            applicationDetails.FarmerLand &&
            applicationDetails.FarmerLand.length > 0
          ">
          <div class="print border bold sec-heading-subsidy-details">{{'LAND_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th *ngIf="showLandOwnerDetails" style="text-align: center; font-size: 0.7rem;">{{'CHECK_OWNER_DETAILS_WITH_LAND_REVENUE_DEPARTMENT' | translate}}</th>
                <th>{{'MEMBER_SNO' | translate}}</th>
                <th>{{'OWNER_NAME' | translate}}</th>
                <th>{{'VILLAGE' | translate}}</th>
                <th>{{'KHEWAT' | translate}}</th>
                <th>{{'UPDATED_KHEWAT' | translate}}</th>
                <th>{{'KHEWAT_AREA' | translate}}</th>
                <th>{{'KHEWAT_BHAG' | translate}}</th>
                <th>{{'OWNER_HISSA_IN_KHEWAT' | translate}}</th>

                <th>{{'MORABBA_NO' | translate}}</th>
                <th>{{'KILLA_NO' | translate}}</th>

                <th>{{'TOTAL_KANALS' | translate}}</th>
                <th>{{'TOTAL_MARLAS' | translate}}</th>

                <th>{{'APPLIED_KANALS' | translate}}</th>
                <th>{{'APPLIED_MARLAS' | translate}}</th>
                <th>{{'APPLIED_AREA' | translate}}</th>

                <th>{{'CROP_TYPE' | translate}}</th>
                <th>{{'YEAR' | translate}}</th>
                <th>{{'UPDATED_YEAR' | translate}}</th>

                <th>{{'LAND_DOC' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.FarmerLand">
                <td *ngIf="showLandOwnerDetails">
                  <div class="flex justify-content-center">
                    <button pButton type="button" (click)="beforeCheckingLandStatus(item)"
                        class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                        pTooltip="{{ 'CHECK_OWNER_DETAILS_WITH_LAND_REVENUE_DEPARTMENT' | translate }}" icon="pi pi-eye"></button>
                  </div>
                </td>
                <td>{{ item?.memberID }}</td>
                <td>{{ item?.OwnerName }}</td>
                <td>{{ item?.Village }}</td>
                <td>{{ item?.Khewat }}</td>
                <td>{{ item?.UpdatedKhewat }}</td>
                <td>{{ item?.KhewatArea }}</td>
                <td>{{ item?.Bhag }}</td>
                <td>{{ item?.OwnerHissa }}</td>

                <td>{{ item?.morabbaNo }}</td>
                <td>{{ item?.killaNo }}</td>

                <td>{{ item?.TotalkanalinKhasra }}</td>
                <td>{{ item?.TotalmarlainKhasra }}</td>

                <td>{{ item?.kanal }}</td>
                <td>{{ item?.marla }}</td>                
                <td>{{ item?.totalArea }}</td>

                <td>{{ item?.cropType }}</td>
                <td>{{ item?.Year }}</td>
                <td>{{ item?.UpdateKhewatYear }}</td>
                <td>
                  <div *ngIf="item?.landPath != '' && item.landPath != null" class="hidden-print">
                    <a style="cursor: pointer" [href]="item?.landPath" target="_blank">{{'VIEW_LAND_DOC' |
                      translate}}</a>
                  </div>
                  <div *ngIf="item?.landPath == '' || item.landPath == null" class="hidden-print">
                    <p>{{'N/A' |
                      translate}}</p>
                  </div>
                </td>
              </tr>
              <!-- <tr>
                <th colspan="2">{{'GRAND_TOTAL_AREA' | translate}}</th>
                <th>{{ totalLandArea | number : '1.2-2'}} {{'ACRE' | translate}}</th>
              </tr> -->
              <tr>
                <th [attr.colspan]="showLandOwnerDetails ? 11 : 1">{{'GRAND_TOTAL_AREA' | translate}}</th>
                <th>{{ totalLandArea | number : '1.2-2'}} {{'ACRE' | translate}}</th>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- land details end -->

        <!-- existing-mi-details -->
        <ng-container *ngIf=" existingMIDetails && existingMIDetails.length > 0 ">
          <div class="print border bold sec-heading-subsidy-details">{{'EXISTING_MI_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'PROGRAM_NAME' | translate}}</th>
                <th>{{'MORABBA_NO' | translate}}</th>
                <th>{{'KILLA_NO' | translate}}</th>
                <th>{{'TOTAL_AREA_IN_ACRE' | translate}}</th>
                <th>{{'IS_SUBSIDY_AVAIL' | translate}}</th>
                <th>{{'YEAR' | translate}}</th>
              </tr>
              <tr *ngFor="let item of existingMIDetails">
                <td>{{ item?.ProgrammeName }}</td>
                <td>{{ item?.Morabba_No }}</td>
                <td>{{ item?.Killa_No }}</td>
                <td>{{ item?.TotalArea }}</td>
                <td>{{ item?.Is_Subsidy_Avail }}</td>
                <td>{{ item?.Year_subsidy }}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- existing-mi-details-ends -->

        <!-- bank details -->
        <ng-container *ngIf="applicationDetails.FarmerBank">
          <div class="print border bold sec-heading-subsidy-details">{{'BANK_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <td>
                  <p class="bold">{{'BANK_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerBank.bankName }}</p>
                </td>
                <td>
                  <p class="bold">{{'ACCOUNT_NO' | translate}}</p>
                  <p>{{ applicationDetails.FarmerBank.accoNumber }}</p>
                </td>
                <td>
                  <p class="bold">{{'ACCOUNT_HOLDER_NAME' | translate}}</p>
                  <p>{{ applicationDetails.FarmerBank.accoHolderName }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="bold">{{'IFSC_CODE' | translate}}</p>
                  <p>{{ applicationDetails.FarmerBank.ifcsCode }}</p>
                </td>
                <td>
                  <p class="bold">{{'PASSBOOK_IMAGE' | translate}}</p>
                  <div class="hidden-print">
                    <p>
                      <a style="cursor: pointer" [href]="applicationDetails?.FarmerBank?.bankPath"
                        target="_blank">{{'BANK_PASSBOOK_IMAGE' | translate}}</a>
                    </p>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- bank details end -->

        <!-- On-Farm tank details -->
        <ng-container *ngIf="
            applicationDetails.OnFarm_Pond_Datas &&
            applicationDetails.OnFarm_Pond_Datas.length > 0
          ">
          <div class="print border bold sec-heading-subsidy-details">{{'ON_FARM_POND_TANK_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'MORABBA_NO' | translate}}</th>
                <th>{{'KILLA_NO' | translate}}</th>
                <th>{{'SIZE_COVERAGE_AREA' | translate}}</th>
                <th>{{'COST_CALCULATION_HSR' | translate}}</th>
                <th>{{'ACTUAL_SUBSIDY_AMOUNT_COMMUNITY_TANK' | translate}}</th>
                <th>{{'ACTUAL_SUBSIDY_AMOUNT_INDIVIDUAL_TANK' | translate}}</th>
                <th>{{'TOP_SIZE' | translate}}</th>
                <th>{{'BOTTOM_SIZE' | translate}}</th>
                <th>{{'DEPTH' | translate}}</th>
                <th>{{'WATER_CAPACITY' | translate}}</th>
                <th>{{'SCAN_COPY' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.OnFarm_Pond_Datas">
                <td>{{ item.morabbaNo }}</td>
                <td>{{ item.killaNo }}</td>
                <td>{{ item?.CoverageArea }}</td>
                <td>{{ item.totalCost }}</td>
                <td>{{ item?.CommunityActualSubsidy }}</td>
                <td>{{ item?.IndividualActualSubsidy }}</td>
                <td>{{ item.topSize }}</td>
                <td>{{ item.bottomSize }}</td>
                <td>{{ item.dept }}</td>
                <td>{{ item.waterCapacity }}</td>
                <td *ngIf="applicationDetails.ConsentPath.length">
                  <a style="cursor: pointer" [href]="applicationDetails?.ConsentPath"
                    target="_blank">{{'VIEW_SIGNATURED_COLLECTIVE_DECLARATION' | translate}}</a>
                </td>
                <td *ngIf="!applicationDetails.ConsentPath.length">{{'N/A' | translate}}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- On-Farm tank details end -->

        <!-- On-Farm solar pump -->
        <ng-container *ngIf="
            applicationDetails.Solar_Pump_Datas &&
            applicationDetails.Solar_Pump_Datas.length > 0
          ">
          <div class="print border bold sec-heading-subsidy-details">{{'ON_FARM_SOLAR_PUMP' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'CONTROLLER_TYPE' | translate}}</th>
                <th>{{'PUMP_CATEGORY' | translate}}</th>
                <th>{{'TYPE' | translate}}</th>
                <th>{{'PUMP_CAPACITY' | translate}}</th>
                <th>{{'FARMER_SHARE' | translate}}</th>
                <th>{{'PRIMARY_VENDOR' | translate}}</th>
                <th>{{'SECONDARY_VENDOR' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.Solar_Pump_Datas">
                <td>{{ item.controlerType }}</td>
                <td>{{ item.pumpCategory }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.pumpCapacity }}</td>
                <td>{{ item.farmerShare }}</td>
                <td>{{ item.primaryVendor }}</td>
                <td>{{ item.secondaryVendor }}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- On-Farm solar pump end -->

        <!-- MI Details -->
        <ng-container *ngIf="
            applicationDetails.New_MI_Datas &&
            applicationDetails.New_MI_Datas.length > 0
          ">
          <div class="print border bold sec-heading-subsidy-details">
            {{'ON_FARMER_MI_COMPONENTS_AND_VENDOR_DETAILS' | translate}}
          </div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'PROGRAMME_NAME' | translate}}</th>
                <th>{{'LAND_DATA' | translate}}</th>
                <th>{{'VENDOR_NAME' | translate}}</th>
                <th>{{'TOTAL_AREA_IN_ACRE' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.New_MI_Datas">
                <td>{{ item.programName }}</td>
                <td>{{ item.landData }}</td>
                <td>{{ item.miVendorName }}</td>
                <td>{{ item.totalArea }}</td>
              </tr>
            </table>

            <div class="border flex justify-content-end">
              <p class="mx-3">
                <b>{{'GRAND_TOTAL_AREA' | translate}}: {{ totalArea | number: "1.2-2" }} {{ 'ACRE' | translate}} </b>
              </p>
            </div>
          </div>
        </ng-container>
        <!-- MI Details end -->

        <!-- water course data start -->
        <ng-container *ngIf="
            applicationDetails.Water_Course_Datas &&
            applicationDetails.Water_Course_Datas.length > 0
          ">
          <div class="print border bold sec-heading-subsidy-details">{{'WATER_COURSE_DETAILS' | translate}}</div>
          <div class="table">
            <table class="border">
              <tr>
                <th>{{'CANAL' | translate}}</th>
                <th>{{'OUTLET' | translate}}</th>
                <th>{{'WORK_TYPE' | translate}}</th>
              </tr>
              <tr *ngFor="let item of applicationDetails.Water_Course_Datas">
                <td>{{ item?.Canal_Outlet_Name }}</td>
                <td>{{ item?.RD }}</td>
                <td>{{ item?.WorkTypeName }}</td>
              </tr>
            </table>
          </div>
        </ng-container>
        <!-- water course data end -->
      </div>

      <!-- pre-estimate-survey -->
      <div class="pre-estimate-form border my-4" *ngIf="preEstimationDataArray?.length > 0">
        <div class="mt-1 form-name">
          <p> {{'PRE_ESTIMATE_SURVEY' | translate}} </p>
        </div>

        <div class="consent-form" *ngFor="let preEstimateDetails of preEstimationDataArray">
          <ng-container>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'APP_ID' | translate}}</p>
                    <p>{{ preEstimateDetails?.AppID }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'PROGRAMME_NAME' | translate}}</p>
                    <p>{{ preEstimateDetails?.ProgramName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SOIL_TYPE' | translate}}</p>
                    <p>{{ preEstimateDetails?.SoilType }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'CROP_TYPE' | translate}}</p>
                    <p>
                      {{ preEstimateDetails?.selectedCropType }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'CROP_NAME' | translate}}</p>
                    <p>
                      {{ preEstimateDetails?.selectedCrop }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'WATER_SOURCE' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterSource }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'WATER_PRESSURE' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterPressure }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'WATER_QUALITY' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterQuality }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'WATER_REQ' | translate}}</p>
                    <p>{{ preEstimateDetails?.WaterQuantity }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'PH' | translate}}</p>
                    <p>{{ preEstimateDetails?.PH }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'EC' | translate}}</p>
                    <p>{{ preEstimateDetails?.EC }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DATE_OF_SURVEY' | translate}}</p>
                    <p>{{ preEstimateDetails?.DateOfSurvey }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p>{{ preEstimateDetails?.PlantSpacing }}</p>
                  </td>

                  <td>
                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                    <p>{{ preEstimateDetails?.RowSpacing }}</p>
                  </td>
                </tr>
              </table>
              <div *ngIf="preEstimateDetails?.newGPSArray?.gpsArray?.[0]?.length > 0">
                <div class="print border bold sec-heading-subsidy-details">
                  {{'LIST_GPS_COORDINATES' | translate}}
                </div>
                <div class="table" *ngFor="let array of preEstimateDetails?.newGPSArray?.gpsArray; let i = index">
                  <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6>
                  <table class="border">
                      <tr>
                          <th>{{'CORNER_ID' | translate}}</th>
                          <th>{{'LATITUDE' | translate}}</th>
                          <th>{{'LONGITUDE' | translate}}</th>
                      </tr>
                      <tr *ngFor="let item of array">
                          <td>{{item.CornerID}}</td>
                          <td>{{item.Latitude}}</td>
                          <td>{{item.Longitude}}</td>
                      </tr>
                  </table>
                </div>
                <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapPreEstimate">
                  <div class="field col-12 md:col-12">
                    <p-gmap [options]="preEstimateDetails?.newGPSArray?.preEstimateOption" type="satellite"
                      [overlays]="preEstimateDetails?.newGPSArray?.preEatimateOverlays"
                      [style]="{'width':'100%','height':'320px'}"></p-gmap>
                  </div>
                </div>

                <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                <div class="p-fluid p-formgrid grid" style="padding:10px">
                  <div *ngFor="let image of preEstimateDetails.listImagePath; let index = index;" class="field m-3" key="index">
                    <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                      (click)="imageClick(index, preEstimateDetails.listImagePath)"
                      style="max-width: 300px; max-height: 300px;" />
                    <div class="flex flex-wrap justify-content-center">
                      <div>{{image.DocumentType}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>
      <!-- pre-estimate-survey end-->


      <!-- MI-Estimation -->
      <div class="mi-estimate-form border my-4" *ngIf="miEstimationDataArray.length > 0">
        <div class="mt-1 form-name">
          <p> {{'MI_ESTIMATION' | translate}} </p>
        </div>

        <div class="consent-form" *ngFor="let vendorApplicationDetails of miEstimationDataArray">
          <!-- <ng-container>
            <div class="sub-header">
              <table class="border">
                <tr>
                  <td>
                    <p class="head">{{'APPLICATION_NO' | translate}}</p>
                    <p class="bold appId">{{
                      vendorApplicationDetails?.AppID
                      }}</p>
                  </td>
                  <td>
                    <p class="head">{{'VENDOR_NAME' | translate}}</p>
                    <p class="bold">{{ vendorApplicationDetails?.VendorName }}</p>
                  </td>
                  <td>
                    <p class="head">{{'PROGRAMME_NAME' | translate}}</p>
                    <p class="bold">
                      {{ vendorApplicationDetails?.ProgrammeName }}
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container> -->

          <!-- personal details start -->
          <ng-container>
            <div class="print border bold sec-heading-subsidy-details">{{'ESTIMATION_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'VENDOR_NAME' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.VendorName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'PROGRAMME_NAME' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.ProgrammeName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'FARMER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ vendorApplicationDetails?.FarmerShareAmount  | number: "1.2-2" }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'COMPONENT_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ vendorApplicationDetails?.ComponentAmount  | number: "1.2-2" }}</p>
                  </td>
                  <!-- <td>
                    <p class="bold">{{'TAX_RATE' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.TaxRate }}</p>
                  </td> -->
                  <td>
                    <p class="bold">{{'DISCOUNT_RATE' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ vendorApplicationDetails?.DiscountRate  | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'OTHER_TRANSPORT_EXPENSES' | translate}}</p>
                    <p>
                      {{ 'INR_SYMBOL' | translate }}{{ vendorApplicationDetails?.TransportOtherExpenses  | number: "1.2-2" }}
                    </p>
                  </td>
                  <!-- <td>
                    <p class="bold">{{'MAX_SUBSIDY_AMOUNT' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.MaxSubSidyAmount }}</p>
                  </td> -->
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'MI_AREA_IN_ACRE' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.MIArea }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'LAND_MAP_PATH' | translate}}</p>
                    <p>
                      <a href="{{ vendorApplicationDetails?.LandMapPath }}" target="_blank">{{ "VIEW_DOC" | translate}}</a>
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'SIGNATURE' | translate}}</p>
                    <p *ngIf="vendorApplicationDetails?.SignaturePath">
                      <a href="{{ vendorApplicationDetails?.SignaturePath }}" target="_blank">{{ "VIEW_DOC" | translate}}</a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'CROP_TYPE' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.selectedCropType }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CROP_NAME' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.selectedCrop }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.PlantSpacing }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.RowSpacing }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'REMARKS' | translate}}</p>
                    <p>{{ vendorApplicationDetails?.Remarks }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>

          <!-- member details -->
          <ng-container *ngIf="
              vendorApplicationDetails?.EstimationComponentDetail &&
              vendorApplicationDetails?.EstimationComponentDetail.length > 0
            ">
            <div class="print border bold sec-heading-subsidy-details">{{'ESTIMATIONS_COMPONENT_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <!-- <th>{{'CAT_ID' | translate}}</th> -->
                  <th>{{'CAT_NAME' | translate}}</th>
                  <!-- <th>{{'COMPONENT_ID' | translate}}</th> -->
                  <th>{{'COMPONENT_NAME' | translate}}</th>
                  <!-- <th>{{'SIZE_ID' | translate}}</th> -->
                  <th>{{'SIZE' | translate}}</th>
                  <th>{{'PRICE' | translate}}</th>
                  <th>{{'QUANTITY' | translate}}</th>
                  <th>{{'TOTAL_COST_IN_INR' | translate}}</th>
                  <!-- <th>GST</th> -->
                </tr>
                <tr *ngFor="let item of vendorApplicationDetails?.EstimationComponentDetail">
                  <!-- <td>{{ item.CatID }}</td> -->
                  <td>{{ item.CatName }}</td>
                  <!-- <td>{{ item.ComponentID }}</td> -->
                  <td>{{ item.ComponentName }}</td>
                  <!-- <td>{{ item.SizeID }}</td> -->
                  <td>{{ item.Size }}</td>
                  <td>{{ 'INR_SYMBOL' | translate }}{{ item.Price }}</td>
                  <td>{{ item.Quantity }}</td>
                  <td>{{ 'INR_SYMBOL' | translate }}{{ item.Price*item.Quantity | number: "1.2-2" }}</td>
                  <!-- <td>{{item.GST}}</td> -->
                </tr>
              </table>
              <div class="border flex justify-content-end">
                <p class="mx-3">
                  <b>{{'COMPONENT_TOTAL' | translate}}: {{ 'INR_SYMBOL' | translate }}{{
                    vendorApplicationDetails?.ComponentAmount/(1-vendorApplicationDetails?.DiscountRate/100) | number:
                    "1.2-2" }}</b>
                </p>
              </div>
            </div>
          </ng-container>
          <!-- member details end -->

          <!-- farmer-share-deposit-details start  -->
          <ng-container *ngIf="showFarmerShareDepositeDetails">
            <div class="print border bold sec-heading-subsidy-details">{{'FARMER_SHARE_DEPOSIT_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'REMITTER_NAME' | translate}}</p>
                    <p>{{ farmerShareDepositeDetails?.RemitterName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CREDIT_DATE_TIME' | translate}}</p>
                    <p>{{ farmerShareDepositeDetails?.CreditDateTime | date:'medium' }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'FROM_ACCOUNT_NO' | translate}}</p>
                    <p>{{ farmerShareDepositeDetails?.FromAccountNumber  }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'UTR' | translate}}</p>
                    <p>{{ farmerShareDepositeDetails?.UTR }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DEPOSIT_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ farmerShareDepositeDetails?.Deposit_Amount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'REFERENCE_ID' | translate}}</p>
                    <p>{{ farmerShareDepositeDetails?.ReferenceID }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
          <!-- farmer-share-deposit-details end  -->
        </div>
      </div>
      <!-- MI-Estimation-end -->


      <!-- Sanction-letter-start -->
      <div class="sanction-letter-form border my-4" *ngIf="sanctionLetterDataArray.length > 0">
        <div class="mt-1 form-name">
          <p> {{'SANCTION_LETTER' | translate}} </p>
        </div>

        <div class="consent-form" *ngFor="let sanctionLetterData of sanctionLetterDataArray">
          <div class="card">
            <ng-container>
              <div class="print border bold" style="margin-top: 1px; text-align: center">
                <div class="flex justify-content-center">
                  <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="40" class="mr-2 mt-1" />
                </div>
                <div class="mt-3 headings">
                  <strong> {{'SANCTION_LETTER' | translate}} </strong>
                  <br />
                  <strong> {{'HARYANA' | translate}} </strong><br />
                  <strong> {{'FINANCIAL_YEAR_2022_2023' | translate}} </strong>
                </div>
              </div>

              <div class="header_sanction my-3 mx-2">
                {{'BASED_ON_DOCUMENTS' | translate}} <b>{{ sanctionLetterData?.FarmerName }}</b> {{'SON_OF' |
                translate}}
                <b>{{ sanctionLetterData?.FatherName }}</b> {{'VILLAGE' | translate}}
                <b>{{ sanctionLetterData?.Village }}</b> {{'DISTRICT' | translate}}
                <b>{{ sanctionLetterData?.District }}</b> {{'SANCTION_MSG' | translate}}:-
              </div>

              <div class="consent-form">
                <div class="table">
                  <table>
                    <tr>
                      <td>
                        <p class="bold">{{'APPLICATION_ID' | translate}}</p>
                        <p>{{ sanctionLetterData?.AppID }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'AREA_IN' | translate}}</p>
                        <p>{{ sanctionLetterData?.Area }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'KHASRA_NO_OR_KILLA_NO' | translate}}</p>
                        <p>{{ sanctionLetterData?.KhasraAndKillaNo }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="bold">{{'CROP' | translate}}</p>
                        <p>{{ sanctionLetterData?.CropName }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'SPACING_MTS' | translate}}</p>
                        <p>{{ sanctionLetterData?.Spacing }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'TYPE_OF_MIS' | translate}}</p>
                        <p>{{ sanctionLetterData?.TypeOfMIS }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="bold">*{{'ESTIMATED_COST_OF_SYSTEMS' | translate}}</p>
                        <p>{{ "INR_SYMBOL" | translate }}{{ sanctionLetterData?.EstimatedCost | number: "1.2-2" }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'ESTIMATED_FARMER_SHARE' | translate}}</p>
                        <p>{{ "INR_SYMBOL" | translate }}{{ sanctionLetterData?.EstimatedFarmerShare | number: "1.2-2" }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'SUBSIDY_SHARE_AS_PER_SCHEME' | translate}}</p>
                        <p>{{ "INR_SYMBOL" | translate }}{{ sanctionLetterData?.SubsidyShare | number: "1.2-2" }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="bold">{{'FARMER_TYPE' | translate}}</p>
                        <p>{{ sanctionLetterData?.FarmerType }}</p>
                      </td>
                      <td>
                        <p class="bold">{{'CATEGORY' | translate}}</p>
                        <p>{{ sanctionLetterData?.Category }}</p>
                      </td>
                    </tr>
                  </table>
                  <p class="bold mt-2">
                    {{'AMOUNT_OF_FARMER_SHARE' | translate}}: {{ "INR_SYMBOL" | translate }}
                    {{ sanctionLetterData?.EstimatedFarmerShare }}
                  </p>
                </div>
              </div>

              <div class="details mt-3">
                <div class="flex justify-content-center bold mb-1">
                  {{'BANK_ACCOUNT_DETAILS' | translate}}
                </div>

                <div class="information">
                  <p>
                    {{'NAME_OF_FARMER_AS_IN_BANK_ACCOUNT' | translate}}:
                    {{ sanctionLetterData?.NameOfFarmerAsOnBankAcc }}
                  </p>
                  <p>{{'NAME_OF_BANK' | translate}}: {{ sanctionLetterData?.NameOfBank }}</p>
                  <p>{{'IFSC_CODE' | translate}}: {{ sanctionLetterData?.IFSCCode }}</p>
                  <p>{{'ACCOUNT_NO'| translate}}.: {{ sanctionLetterData?.AccountNo }}</p>
                  <p>{{'BRANCH_NAME' | translate}}: {{ sanctionLetterData?.BranchName }}</p>
                </div>

                <div class="letter mt-3">
                  <p>{{'TO_' | translate}}</p>
                  <div class="mx-3">
                    <p>
                      {{'SRI_SMT' | translate}}, <b>{{ sanctionLetterData?.FarmerName }}</b> S/o
                      <b>{{ sanctionLetterData?.FatherName }}</b> Vill.
                      <b>{{ sanctionLetterData?.Village }}</b> District
                      <b>{{ sanctionLetterData?.District }}</b>
                    </p>
                    <p>{{'REGISTERED_MANUFACTURER' | translate}} <b>{{ sanctionLetterData?.VendorName }}</b></p>
                    <p>{{'DISTRICT_OFFICER_INCHARGE_OF_MI' | translate}} <b>{{ sanctionLetterData?.XENName }} </b>
                      <b>(XEN {{ sanctionLetterData?.XENDistrict }})</b>
                    </p>
                  </div>
                </div>
              </div>
              <div class="note mt-5">
                <p>
                  *{{'NOTE' | translate}}: {{"AMOUNT_OF_ASSISTANCE_PHYSICAL_VERIFICATION" | translate}}.<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{'APPROVED_MAX_ASSISTANCE' | translate}}.
                </p>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Sanction-letter-end -->


      <!-- MI-BOQ -->
      <div class="mi-boq-form border my-4" *ngIf="miBOQDataArray.length > 0">
        <div class="mt-1 form-name">
          <p> {{'MI_BOQ' | translate}} </p>
        </div>
        <div class="consent-form" *ngFor="let appDetails of miBOQDataArray">
          <ng-container>
            <div class="print border bold sec-heading-subsidy-details">{{'BOQ_DETAILS' | translate}}</div>

            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'PROGRAMME_NAME' | translate}}</p>
                    <p>{{ appDetails?.ProgrammeName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'FARMER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ appDetails?.FarmerShareAmount | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BILLED_COMPONENT_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ appDetails?.ComponentAmount | number: "1.2-2" }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'BILL_COPY' | translate}}</p>
                    <p>
                      <a href="{{ appDetails?.BillCopyPath }}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                    </p>
                  </td>
                  <!-- <td>
                    <p class="bold">{{'TAX_RATE' | translate}}</p>
                    <p>{{ appDetails?.TaxRate }}</p>
                  </td> -->
                  <td>
                    <p class="bold">{{'DISCOUNT_RATE' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ appDetails?.DiscountRate | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'OTHER_TRANSPORT_EXPENSES' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ appDetails?.TransportOtherExpenses | number: "1.2-2" }}</p>
                  </td>
                  <!-- <td>
                    <p class="bold">{{'MAX_SUBSIDY_AMOUNT' | translate}}</p>
                    <p>{{ appDetails?.MaxSubSidyAmount }}</p>
                  </td> -->
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'MI_AREA_IN_ACRE' | translate}}</p>
                    <p>{{ appDetails?.MIArea }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p>{{ appDetails?.PlantSpacing }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                    <p>{{ appDetails?.RowSpacing }}</p>
                  </td>
                </tr>
                <tr>
                <td>
                  <p class="bold">{{'LAND_MAP_PATH' | translate}}</p>
                  <p>
                    <a href="{{ appDetails?.LandMapPath }}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                  </p>
                </td>
                  <td>
                    <p class="bold">{{'REMARKS' | translate}}</p>
                    <p>{{ appDetails?.Remarks }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>

          <!-- member details -->
          <ng-container *ngIf="
              appDetails?.EstimationComponentDetail &&
              appDetails?.EstimationComponentDetail.length > 0
            ">
            <div class="print border bold sec-heading-subsidy-details">{{'BOQ_COMPONENT_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <!-- <th>{{'CAT_ID' | translate}}</th> -->
                  <th>{{'CAT_NAME' | translate}}</th>
                  <!-- <th>{{'COMPONENT_ID' | translate}}</th> -->
                  <th>{{'COMPONENT_NAME' | translate}}</th>
                  <!-- <th>{{'SIZE_ID' | translate}}</th> -->
                  <th>{{'SIZE' | translate}}</th>
                  <th>{{'PRICE' | translate}}</th>
                  <th>{{'QUANTITY' | translate}}</th>
                  <th>{{'TOTAL_COST_IN_INR' | translate}}</th>
                  <!-- <th>GST</th> -->
                </tr>
                <ng-container *ngFor="let item of appDetails?.EstimationComponentDetail">
                  <tr>
                    <!-- <td>{{ item.CatID }}</td> -->
                    <td>{{ item.CatName }}</td>
                    <!-- <td>{{ item.ComponentID }}</td> -->
                    <td>{{ item.ComponentName }}</td>
                    <!-- <td>{{ item.SizeID }}</td> -->
                    <td>{{ item.Size }}</td>
                    <td>{{ 'INR_SYMBOL' | translate }}{{ item.Price }}</td>
                    <td>{{ item.Quantity }}</td>
                    <td>{{ 'INR_SYMBOL' | translate }}{{ item.Price*item.Quantity | number: "1.2-2" }}</td>
                    <!-- <td>{{item.GST}}</td> -->
                  </tr>
                  <tr *ngIf="item?.inventory && item?.inventory?.length > 0">
                    <td colspan="12">
                      <div class="print border bold">{{item.ComponentName}} - Inventory
                        <div class="table">
                          <table class="border">
                            <tr>
                              <th>Lot No</th>
                              <th>Batch No</th>
                              <!-- <th>Quantity</th> -->
                              <th>Quantity Used</th>
                              <th>Remaining Quantity</th>
                            </tr>
                            <tr *ngFor="let rowdata of item?.inventory">
                              <td>{{rowdata.lotNo}}</td>
                              <td>{{rowdata.batchNumber}}</td>
                              <!-- <td>{{rowdata.Quantity}}</td> -->
                              <td>{{rowdata.QuantityUsed}}</td>
                              <td>{{rowdata.remainingQuantity}}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </table>
              <div class="border flex justify-content-end">
                <p class="mx-3">
                  <b>{{'COMPONENT_TOTAL' | translate}}: {{ 'INR_SYMBOL' | translate }}{{ appDetails?.ComponentAmount/(1-appDetails?.DiscountRate/100)
                    | number: "1.2-2" }} </b>
                </p>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- member details end -->
      </div>
      <!-- Boq-end -->


      <!-- MI-survey -->
      <div class="physical-survey-form border my-4" *ngIf="physicalSurveyDetailsArray.length > 0">
        <div class="mt-1 form-name">
          <p> {{'MI_PHYSICAL_SURVEY/VERIFICATION' | translate}} </p>
        </div>
        <div class="consent-form my-3" *ngFor="let physicalSurveyDetails of physicalSurveyDetailsArray">
          <ng-container>
            <div class="print border bold sec-heading-subsidy-details" style="margin-top: -0.5px">
              {{'MI_SURVEY_DETAILS' | translate}}
            </div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'TOTAL_COST_OF_VERIFICATION' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.TotalCostVerification | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'FARMER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.FarmerShare | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TRANSPORT_OTHER_CHARGES' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.BilledTransportAmount | number: "1.2-2" }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'MI_AREA_IN_ACRE' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.MIArea | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOTAL_COST_IN_INR' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.TotalCostVerification | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CHALLAN_TYPE' | translate}}</p>
                    <p>
                      {{ physicalSurveyDetails?.ChallanType }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p> {{ physicalSurveyDetails?.PlantSpacing | number: "1.2-2" }} </p>
                  </td>
                  <td>
                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                    <p> {{ physicalSurveyDetails?.RowSpacing | number: "1.2-2" }} </p>
                  </td>
                  <td>
                    <p class="bold">{{'MAX_SUBSIDY' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.ProData_MaxSubsidy | number: "1.2-2"}}</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <p class="bold">{{'LAND_DETAILS' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.LandDetail }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'JE_NAME' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.JEName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SDO_NAME' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.SDOName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'XEN_NAME' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.XENName }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'JE_REMARKS' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.JERemarks }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SDO_REMARKS' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.SDORemarks }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SURVEY_TYPE_(SDO)' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.SurveyType == 0 ? "From Office": "From Field" }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'XEN_REMARKS' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.XENRemarks }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SURVEY_TYPE_(XEN)' | translate}}</p>
                    <p>{{ physicalSurveyDetails?.SurveyType == 0 ? "From Office": "From Field" }}</p>
                  </td>
                </tr>

              </table>
            </div>
          </ng-container>

          <!-- Component details -->
          <ng-container *ngIf="
          physicalSurveyDetails?.listDataForPhysicalVer &&
          physicalSurveyDetails?.listDataForPhysicalVer.length > 0
            ">
            <div class="print border bold sec-heading-subsidy-details">{{'MI_SURVEY_COMPONENT_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <!-- <th>{{'CAT_ID' | translate}}</th> -->
                  <th>{{'CAT_NAME' | translate}}</th>
                  <!-- <th>{{'COMPONENT_ID' | translate}}</th> -->
                  <th>{{'COMPONENT_NAME' | translate}}</th>
                  <!-- <th>{{'SIZE_ID' | translate}}</th> -->
                  <th>{{'SIZE' | translate}}</th>
                  <th>{{'PRICE' | translate}}</th>
                  <th>{{'QUANTITY' | translate}}</th>
                  <th>{{'TOTAL_COST_IN_INR' | translate}}</th>
                  <!-- <th>GST</th> -->
                </tr>
                <tr *ngFor="let item of physicalSurveyDetails?.listDataForPhysicalVer">
                  <!-- <td>{{ item.CatId }}</td> -->
                  <td>{{ item.ProgrammeName }}</td>
                  <!-- <td>{{ item.CompId }}</td> -->
                  <td>{{ item.component }}</td>
                  <!-- <td>{{ item.SizeId }}</td> -->
                  <td>{{ item.size }}</td>
                  <td>{{ 'INR_SYMBOL' | translate }}{{ item.Price }}</td>
                  <td>{{ item.ActualQuantity }}</td>
                  <td>{{ 'INR_SYMBOL' | translate }}{{ item.Price*item.ActualQuantity }}</td>
                  <!-- <td>{{item.GST}}</td> -->
                </tr>
              </table>
              <div class="border flex justify-content-end">
                <p class="mx-3">
                  <b>{{'COMPONENT_TOTAL' | translate}}: {{ 'INR_SYMBOL' | translate }}{{ (physicalSurveyDetails?.TotalCostVerification -
                    physicalSurveyDetails?.BilledTransportAmount) | number: "1.2-2" }} </b>
                </p>
              </div>
            </div>
          </ng-container>
          <!-- Component details end -->

          <!-- List Coordinates and attachments -->
          <ng-container>
            <div class="table">
              <div *ngIf="physicalSurveyDetails?.newGPSjeArray?.gpsArray?.[0]?.length > 0">
                <div class="print border bold sec-heading-subsidy-details" *ngIf="physicalSurveyDetails?.listGPSCoordinatesJE.length > 0">
                  {{'LIST_GPS_COORDINATES_JE' | translate}}
                </div>
                <div class="table" *ngFor="let array of physicalSurveyDetails?.newGPSjeArray?.gpsArray; let i = index">
                  <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6>
                  <table class="border">
                      <tr>
                          <th>{{'CORNER_ID' | translate}}</th>
                          <th>{{'LATITUDE' | translate}}</th>
                          <th>{{'LONGITUDE' | translate}}</th>
                      </tr>
                      <tr *ngFor="let item of array">
                          <td>{{item.CornerID}}</td>
                          <td>{{item.Latitude}}</td>
                          <td>{{item.Longitude}}</td>
                      </tr>
                  </table>
                </div>
                <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapJE">
                  <div class="field col-12 md:col-12">
                    <p-gmap [options]="physicalSurveyDetails?.newGPSjeArray?.optionsJE" type="satellite"
                      [overlays]="physicalSurveyDetails?.newGPSjeArray?.overlaysJE"
                      [style]="{'width':'100%','height':'320px'}"></p-gmap>
                  </div>
                </div>
                <div class="print border bold" *ngIf="physicalSurveyDetails.listImagePathJE.length > 0">{{'LIST_IMAGE_PATH_JE' | translate}}</div>
                <div class="p-fluid p-formgrid grid" style="padding:10px">
                  <div *ngFor="let image of physicalSurveyDetails.listImagePathJE; let index = index;" class="field m-3" key="index">
                    <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                      (click)="imageClick(index, physicalSurveyDetails.listImagePathJE)"
                      style="max-width: 300px; max-height: 300px;" />
                    <div class="flex flex-wrap justify-content-center">
                      <div>{{image.DocumentType}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="physicalSurveyDetails?.newGPSsdoArray?.gpsArray?.[0].length > 0">
                <div class="print border bold sec-heading-subsidy-details" *ngIf="physicalSurveyDetails?.listGPSCoordinatesSDO.length > 0">
                  {{'LIST_GPS_COORDINATES_SDO' | translate}}
                </div>
                <div class="table" *ngFor="let array of physicalSurveyDetails?.newGPSsdoArray?.gpsArray; let i = index">
                  <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6>
                  <table class="border">
                      <tr>
                          <th>{{'CORNER_ID' | translate}}</th>
                          <th>{{'LATITUDE' | translate}}</th>
                          <th>{{'LONGITUDE' | translate}}</th>
                      </tr>
                      <tr *ngFor="let item of array">
                          <td>{{item.CornerID}}</td>
                          <td>{{item.Latitude}}</td>
                          <td>{{item.Longitude}}</td>
                      </tr>
                  </table>
                </div>
                <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapSDO">
                  <div class="field col-12 md:col-12">
                    <p-gmap [options]="physicalSurveyDetails?.newGPSsdoArray?.optionsSDO" type="satellite"
                      [overlays]="physicalSurveyDetails?.newGPSsdoArray?.overlaysSDO"
                      [style]="{'width':'100%','height':'320px'}"></p-gmap>
                  </div>
                </div>
                <div class="print border bold" *ngIf="physicalSurveyDetails.listImagePathSDO.length > 0">{{'LIST_IMAGE_PATH_SDO' | translate}}</div>
                <div class="p-fluid p-formgrid grid" style="padding:10px">
                  <div *ngFor="let image of physicalSurveyDetails.listImagePathSDO; let index = index;" class="field m-3" key="index">
                    <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                      (click)="imageClick(index, physicalSurveyDetails.listImagePathSDO)"
                      style="max-width: 300px; max-height: 300px;" />
                    <div class="flex flex-wrap justify-content-center">
                      <div>{{image.DocumentType}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="physicalSurveyDetails?.newGPSxenArray?.gpsArray?.[0].length > 0">
                <div class="print border bold sec-heading-subsidy-details" *ngIf="physicalSurveyDetails?.listGPSCoordinatesXEN.length > 0">
                  {{'LIST_GPS_COORDINATES_XEN' | translate}}
                </div>
                <div class="table" *ngFor="let array of physicalSurveyDetails?.newGPSxenArray?.gpsArray; let i = index">
                  <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6>
                  <table class="border">
                      <tr>
                          <th>{{'CORNER_ID' | translate}}</th>
                          <th>{{'LATITUDE' | translate}}</th>
                          <th>{{'LONGITUDE' | translate}}</th>
                      </tr>
                      <tr *ngFor="let item of array">
                          <td>{{item.CornerID}}</td>
                          <td>{{item.Latitude}}</td>
                          <td>{{item.Longitude}}</td>
                      </tr>
                  </table>
                </div>
                <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapXEN">
                  <div class="field col-12 md:col-12">
                    <p-gmap [options]="physicalSurveyDetails?.newGPSxenArray?.optionsXEN" type="satellite"
                      [overlays]="physicalSurveyDetails?.newGPSxenArray?.overlaysXEN"
                      [style]="{'width':'100%','height':'320px'}"></p-gmap>
                  </div>
                </div>
                <div class="print border bold" *ngIf="physicalSurveyDetails.listImagePathXEN.length > 0">{{'LIST_IMAGE_PATH_XEN' | translate}}</div>
                <div class="p-fluid p-formgrid grid" style="padding:10px">
                  <div *ngFor="let image of physicalSurveyDetails.listImagePathXEN; let index = index;" class="field m-3" key="index">
                    <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                      (click)="imageClick(index, physicalSurveyDetails.listImagePathXEN)"
                      style="max-width: 300px; max-height: 300px;" />
                    <div class="flex flex-wrap justify-content-center">
                      <div>{{image.DocumentType}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- List Coordinates and attachments end -->

          <!-- Calculated Subsidy details -->
          <ng-container *ngIf="physicalSurveyDetails?.calculatedSubsidyDataForMIPhys">
            <div class="print border bold sec-heading-subsidy-details">{{'MI_CALCULATED_SUBSIDY_DETAIL' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.StateShareAmount | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.CenterShareAmount | number: "1.2-2" }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'SUBSIDY_TO_FARMER_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.SubsidyToFarmerAmount | number: "1.2-2" }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'SUBSIDY_TO_VENDOR_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.SubsidyToVendorAmount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'FARMER_REFUND_AMOUNT' | translate}}</p>
                    <p>{{ 'INR_SYMBOL' | translate }}{{ physicalSurveyDetails?.calculatedSubsidyDataForMIPhys?.FarmerRefundAmount }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
          <!-- Calculated Subsidy details End -->
        </div>

      </div>
      <!-- MI-survey-end  -->

      <!-- Pond Tank Stage-1 -->
      <div class="tank-stage1-form border my-4" *ngIf="PondVerData">
        <div class="mt-2 form-name">
          <h5> {{'TANK_STAGE1' | translate}} </h5>
        </div>
        <div class="consent-form my-3">
          <ng-container>
            <div class="print border bold " style="margin-top:0.5px;">{{'TANK_STAGE1_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                    <p>{{PondVerData?.topLength | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                    <p>{{PondVerData?.topBreadth | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                    <p>{{PondVerData?.bottomLength | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                    <p>{{PondVerData?.bottomBreadth | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_SIZE' | translate}}</p>
                    <p>{{PondVerData?.topSize | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                    <p>{{PondVerData?.bottomSize | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'DEPTH' | translate}}</p>
                    <p>{{PondVerData?.depth | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'VOLUME_EARTH_WORK' | translate}}</p>
                    <p>{{PondVerData?.VolumeEarthWork | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                    <p>{{PondVerData?.estimateCost | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'LATITUDE' | translate}}</p>
                    <p>{{PondVerData?.tankLat}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'LONGITUDE' | translate}}</p>
                    <p>{{PondVerData?.tankLng}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                    <p>{{PondVerData?.ActualSubsidy_Stage1 | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'USER_ID' | translate}}</p>
                    <p>{{PondVerData?.UserID}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                    <p>{{PondVerData?.StateShare_Amount | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{PondVerData?.CenterShare_Amount | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'REMARKS' | translate}}</p>
                    <p>{{PondVerData?.Remarks}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'JE_REMARKS' | translate}}</p>
                    <p>{{PondVerData?.JERemarks}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'XEN_REMARKS' | translate}}</p>
                    <p>{{PondVerData?.XENRemarks}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'DA_REMARKS' | translate}}</p>
                    <p>{{PondVerData?.DARemarks}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DMICADA_REMARK' | translate}}</p>
                    <p>{{PondVerData?.DMICADAReamrks}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ADMIN_REMARK' | translate}}</p>
                    <p>{{PondVerData?.AdminRemarks}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'UPLOADED_COPY' | translate}}</p>
                    <p><a href="{{PondVerData?.estimateCopy}}" target="_blank">{{'VIEW' | translate}}</a></p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>

          <!-- <div class="card" *ngIf="prev" style=" background-color: rgb(201,209,209);"> -->
          <div class="print border bold">{{'TANK_STAGE1_ATTACHMENT_DETAILS' | translate}}</div>
          <div class="p-fluid p-formgrid grid" style="padding:10px">
            <div *ngFor="let image of PondVerData?.listImagePathJE; let index = index;" class="field m-3" key="index">
              <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, PondVerData?.listImagePathJE)"
                style="max-width: 300px; max-height: 300px;" />
              <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
              </div>
            </div>
          </div>
          <div class="p-fluid p-formgrid grid" style="padding:10px">
            <div *ngFor="let image of PondVerData?.listImagePathXEN; let index = index;" class="field m-3" key="index">
              <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, PondVerData?.listImagePathXEN)"
                style="max-width: 300px; max-height: 300px;" />
              <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <!-- </div> -->


        </div>
      </div>
      <!-- Tank Stage-1-end -->

      <!-- Tank Stage-2 -->
      <div class="tank-stage1-form border my-4" *ngIf="PondVerDataStage2">
        <div class="mt-2 form-name">
          <h5> {{'TANK_STAGE2' | translate}} </h5>
        </div>
        <div class="consent-form my-3">
          <ng-container>
            <div class="print border bold " style="margin-top:0.5px;">{{'TANK_STAGE2_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'TYPE_OF_POND' | translate}}</p>
                    <p>{{PondVerDataStage2?.TypeOfPond}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.topLength | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.topBreadth | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.bottomLength | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.bottomBreadth | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                    <p>{{PondVerDataStage2?.bottomSize | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'TOP_SIZE' | translate}}</p>
                    <p>{{PondVerDataStage2?.topSize | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DEPTH' | translate}}</p>
                    <p>{{PondVerDataStage2?.depth | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'USER_ID' | translate}}</p>
                    <p>{{PondVerDataStage2?.UserID}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'LATITUDE' | translate}}</p>
                    <p>{{PondVerDataStage2?.tankLat}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'LONGITUDE' | translate}}</p>
                    <p>{{PondVerDataStage2?.tankLng}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOTAL_ESTIMATED_COST' | translate}}</p>
                    <p>{{PondVerDataStage2?.TotalEstimatedCost | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'TOTAL_ESTIMATED_SUBSIDY' | translate}}</p>
                    <p>{{PondVerDataStage2?.TotalEstimatedSubsidy | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                    <p>{{PondVerDataStage2?.StateShare_Amount | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                    <p>{{PondVerDataStage2?.CenterShare_Amount | number : '1.2-2'}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'ASSISTANCE_PAID_AT_STAGE2_' | translate}}</p>
                    <p>{{PondVerDataStage2?.AssistancePaidAtStage1}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                    <p>{{PondVerDataStage2?.ActualSubsidy_Stage1}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ESTIMATE_COPY_STAGE1' | translate}}</p>
                    <p><a href="{{PondVerDataStage2?.estimateCopy_Stage1}}" target="_blank">{{'VIEW' | translate}}</a>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'ACTUAL_SUBSIDY_STAGE2' | translate}}</p>
                    <p>{{PondVerDataStage2?.ActualSubsidy_Stage2 | number : '1.2-2'}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'MEASUREMENT_BOOK_COPY_STAGE2' | translate}}</p>
                    <p><a href="{{PondVerDataStage2?.MeasurementCopy}}" target="_blank">{{'VIEW' | translate}}</a></p>
                  </td>
                  <td>
                    <p class="bold">{{'REMARKS' | translate}}</p>
                    <p>{{PondVerDataStage2?.Remarks}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'JE_REMARKS' | translate}}</p>
                    <p>{{PondVerDataStage2?.JERemarks}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'XEN_REMARKS' | translate}}</p>
                    <p>{{PondVerDataStage2?.XENRemarks}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'DA_REMARKS' | translate}}</p>
                    <p>{{PondVerDataStage2?.DARemarks}}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'DMICADA_REMARK' | translate}}</p>
                    <p>{{PondVerDataStage2?.DMICADAReamrks}}</p>
                  </td>
                  <td>
                    <p class="bold">{{'ADMIN_REMARK' | translate}}</p>
                    <p>{{PondVerDataStage2?.AdminRemarks}}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
          <div class="print border bold">{{'TANK_STAGE2_ATTACHMENT_DETAILS' | translate}}</div>
          <div class="p-fluid p-formgrid grid" style="padding:10px">
            <div *ngFor="let image of PondVerDataStage2?.listImagePathJE; let index = index;" class="field m-3"
              key="index">
              <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, PondVerDataStage2?.listImagePathJE)"
                style="max-width: 300px; max-height: 300px;" />
              <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
              </div>
            </div>
          </div>
          <div class="p-fluid p-formgrid grid" style="padding:10px">
            <div *ngFor="let image of PondVerDataStage2?.listImagePathXEN; let index = index;" class="field m-3"
              key="index">
              <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, PondVerDataStage2?.listImagePathXEN)"
                style="max-width: 300px; max-height: 300px;" />
              <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <!-- Tank Stage-2-end -->


      <!-- Tank-Stage-3-start -->
      <div class="tank-stage1-form border my-4" *ngIf="pondS1Exist || pondS2Exist">
        <div class="mt-1 form-name">
          <p> {{'POND_TANK_DETAILS' | translate}} </p>
        </div>

        <div class="consent-form">
          <div *ngIf="pondS1Exist">
            <div class="print sec-heading d-flex justify-content-center">{{'POND_TANK_STAGE1_FIELD_PHYSICAL_SURVEY_DETAILS' | translate}}</div>
            <!-- JE SURVEY STAGE-1 Content Start -->
            <ng-container *ngIf="surveyStage1JE?.IsExist == 1 && surveyStage1JE?.ActionType == 'SurveyStg1_JE'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SURVEY_STAGE1_JE' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ surveyStage1JE?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1JE?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1JE?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1JE?.ABY }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1JE?.Topup }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ surveyStage1JE?.Coverage_Area }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ surveyStage1JE?.NoOfBeneficiary }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'VOLUME_EARTH_WORK' | translate}}</p>
                      <p>{{ surveyStage1JE?.VolumeEarthWork }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                      <p>{{ surveyStage1JE?.bottomBreadth }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                      <p>{{ surveyStage1JE?.bottomLength }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                      <p>{{ surveyStage1JE?.bottomSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'DEPTH' | translate}}</p>
                      <p>{{ surveyStage1JE?.depth }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ surveyStage1JE?.estimateCost }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'TANK_LAT' | translate}}</p>
                      <p>{{ surveyStage1JE?.tankLat }}</p>
                    </td> -->
                    <!-- <td>
                      <p class="bold">{{'TANK_LONG' | translate}}</p>
                      <p>{{ surveyStage1JE?.tankLng }}</p>
                    </td> -->
                    <td>
                      <p class="bold">{{'TOP_SIZE' | translate}}</p>
                      <p>{{ surveyStage1JE?.topSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                      <p>{{ surveyStage1JE?.topBreadth }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                      <p>{{ surveyStage1JE?.topLength }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'JE-EW_REMARK_STAGE1' | translate}}</p>
                      <p>{{ remarksData?.JERemarks_Stg1 }}</p>
                    </td>
                    <td *ngIf="surveyStage1JE?.estimateCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{surveyStage1JE?.estimateCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>

              <!-- <div *ngIf="jeTanks1SurveyData?.actionType == 'JE_Survey_Tank_Stage1'">
                <div class="print border bold sec-heading-subsidy-details">
                  {{'LIST_GPS_COORDINATES' | translate}}
                </div>
                <div class="table" *ngFor="let array of jeTanks1SurveyData?.newGPSjeArray?.gpsArray; let i = index">
                  <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6>
                  <table class="border">
                      <tr>
                          <th>{{'CORNER_ID' | translate}}</th>
                          <th>{{'LATITUDE' | translate}}</th>
                          <th>{{'LONGITUDE' | translate}}</th>
                      </tr>
                      <tr *ngFor="let item of array">
                          <td>{{item.CornerID}}</td>
                          <td>{{item.Latitude}}</td>
                          <td>{{item.Longitude}}</td>
                      </tr>
                  </table>
                </div> -->
                <!-- <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapPreEstimate">
                  <div class="field col-12 md:col-12">
                    <p-gmap [options]="preEstimateDetails?.newGPSArray?.preEstimateOption" type="satellite"
                      [overlays]="preEstimateDetails?.newGPSArray?.preEatimateOverlays"
                      [style]="{'width':'100%','height':'320px'}"></p-gmap>
                  </div>
                </div> -->

                <!-- <div class="print border bold">{{'POND_STAGE1_JE_ATTACHMENT_DETAILS' | translate}}</div>
                <div class="p-fluid p-formgrid grid" style="padding:10px">
                  <div *ngFor="let image of jeTanks2SurveyData?.attachmenst; let index = index;" class="field m-3" key="index">
                    <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                      (click)="imageClick(index, preEstimateDetails.listImagePath)"
                      style="max-width: 300px; max-height: 300px;" />
                      <p-image 
                          [src]="image['ImagePath']" 
                          [previewImageSrc]="image['ImagePath']"
                          alt="250" 
                          width="250" 
                          [preview]="true"></p-image>
                    <div class="flex flex-wrap justify-content-center">
                      <div>{{image.DocumentType}}</div>
                    </div>
                  </div>
                </div> -->
              <!-- </div> -->

              <div>
                <div *ngIf="jeTanks1SurveyData?.newGPSjeArray?.gpsArray?.length > 0">
                  <!-- <div class="print border bold sec-heading-subsidy-details"> -->
                  <div class="print border bold">
                    {{'LIST_GPS_COORDINATES' | translate}}
                  </div>
                  <div class="table mx-2 dashboardTable">
                    <!-- <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6> -->
                    <p-table [value]="jeTanks1SurveyData?.newGPSjeArray?.gpsArray" responsiveLayout="scroll">
                      <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CORNER_ID' | translate}}</th>
                            <th>{{'LATITUDE' | translate}}</th>
                            <th>{{'LONGITUDE' | translate}}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>{{item.CornerID}}</td>
                            <td>{{item.Latitude}}</td>
                            <td>{{item.Longitude}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapJETankS1">
                    <div class="field col-12 md:col-12">
                      <p-gmap [options]="jeTanks1SurveyData?.newGPSjeArray?.options" type="satellite"
                        [overlays]="jeTanks1SurveyData?.newGPSjeArray?.overlays"
                        [style]="{'width':'100%','height':'320px'}"></p-gmap>
                    </div>
                  </div>
                </div>

                <div *ngIf="jeTanks1SurveyData?.attachements?.length > 0">
                  <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                  <div class="p-fluid p-formgrid grid" style="padding:10px">
                    <div *ngFor="let image of jeTanks1SurveyData.attachements; let index = index;" class="field m-3" key="index">
                      <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                        (click)="imageClick(index, jeTanks1SurveyData.attachements)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image.DocumentType}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- JE SURVEY STAGE-1 Content End -->

            <!-- SDO SURVEY STAGE-1 Content Start -->
            <!-- <ng-container> -->
            <ng-container *ngIf="surveyStage1SDO?.IsExist == 1 && surveyStage1XEN?.ActionType == 'SurveyStg1_SDO'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SURVEY_STAGE1_SDO' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ surveyStage1SDO?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1SDO?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1SDO?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1SDO?.ABY }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1SDO?.Topup }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ surveyStage1SDO?.Coverage_Area }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ surveyStage1SDO?.NoOfBeneficiary }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'VOLUME_EARTH_WORK' | translate}}</p>
                      <p>{{ surveyStage1SDO?.VolumeEarthWork }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                      <p>{{ surveyStage1SDO?.bottomBreadth }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                      <p>{{ surveyStage1SDO?.bottomLength }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                      <p>{{ surveyStage1SDO?.bottomSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'DEPTH' | translate}}</p>
                      <p>{{ surveyStage1SDO?.depth }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ surveyStage1SDO?.estimateCost }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LAT' | translate}}</p>
                      <p>{{ surveyStage1SDO?.tankLat }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LONG' | translate}}</p>
                      <p>{{ surveyStage1SDO?.tankLng }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_SIZE' | translate}}</p>
                      <p>{{ surveyStage1SDO?.topSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                      <p>{{ surveyStage1SDO?.topBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                      <p>{{ surveyStage1SDO?.topLength }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'SDO_REMARK_STAGE1' | translate}}</p>
                      <p>{{ remarksData?.SDORemarks_Stg1 }}</p>
                    </td>
                    <td *ngIf="surveyStage1SDO?.estimateCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{surveyStage1SDO?.estimateCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>

              <div>
                <div *ngIf="sdoTank1SurveyData?.newGPSjeArray?.gpsArray?.length > 0">
                  <!-- <div class="print border bold sec-heading-subsidy-details"> -->
                  <div class="print border bold">
                    {{'LIST_GPS_COORDINATES' | translate}}
                  </div>
                  <div class="table mx-2 dashboardTable">
                    <!-- <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6> -->
                    <p-table [value]="sdoTank1SurveyData?.newGPSjeArray?.gpsArray" responsiveLayout="scroll">
                      <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CORNER_ID' | translate}}</th>
                            <th>{{'LATITUDE' | translate}}</th>
                            <th>{{'LONGITUDE' | translate}}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>{{item.CornerID}}</td>
                            <td>{{item.Latitude}}</td>
                            <td>{{item.Longitude}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapJETankS1">
                    <div class="field col-12 md:col-12">
                      <p-gmap [options]="sdoTank1SurveyData?.newGPSjeArray?.options" type="satellite"
                        [overlays]="sdoTank1SurveyData?.newGPSjeArray?.overlays"
                        [style]="{'width':'100%','height':'320px'}"></p-gmap>
                    </div>
                  </div>
                </div>

                <div *ngIf="sdoTank1SurveyData.attachements.length > 0">
                  <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                  <div class="p-fluid p-formgrid grid" style="padding:10px">
                    <div *ngFor="let image of sdoTank1SurveyData.attachements; let index = index;" class="field m-3" key="index">
                      <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                        (click)="imageClick(index, sdoTank1SurveyData.attachements)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image.DocumentType}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- SDO SURVEY STAGE-1 Content End -->

            <!-- XEN SURVEY STAGE-1 Content Start -->
            <ng-container *ngIf="surveyStage1XEN?.IsExist == 1 && surveyStage1XEN?.ActionType == 'SurveyStg1_XEN'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SURVEY_STAGE1_XEN' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ surveyStage1XEN?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.ABY }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.Topup }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ surveyStage1XEN?.Coverage_Area }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ surveyStage1XEN?.NoOfBeneficiary }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'VOLUME_EARTH_WORK' | translate}}</p>
                      <p>{{ surveyStage1XEN?.VolumeEarthWork }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                      <p>{{ surveyStage1XEN?.bottomBreadth }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                      <p>{{ surveyStage1XEN?.bottomLength }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                      <p>{{ surveyStage1XEN?.bottomSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'DEPTH' | translate}}</p>
                      <p>{{ surveyStage1XEN?.depth }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ surveyStage1XEN?.estimateCost }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LAT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.tankLat }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LONG' | translate}}</p>
                      <p>{{ surveyStage1XEN?.tankLng }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_SIZE' | translate}}</p>
                      <p>{{ surveyStage1XEN?.topSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                      <p>{{ surveyStage1XEN?.topBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                      <p>{{ surveyStage1XEN?.topLength }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'XEN_REMARK_STAGE1' | translate}}</p>
                      <p>{{ remarksData?.XENRemarks_Stg1 }}</p>
                    </td>
                    <td *ngIf="surveyStage1XEN?.estimateCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{surveyStage1XEN?.estimateCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>

              <div>
                <div *ngIf="xenTank1SurveyData?.newGPSjeArray?.gpsArray?.length > 0">
                  <!-- <div class="print border bold sec-heading-subsidy-details"> -->
                  <div class="print border bold">
                    {{'LIST_GPS_COORDINATES' | translate}}
                  </div>
                  <div class="table mx-2 dashboardTable">
                    <!-- <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6> -->
                    <p-table [value]="xenTank1SurveyData?.newGPSjeArray?.gpsArray" responsiveLayout="scroll">
                      <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CORNER_ID' | translate}}</th>
                            <th>{{'LATITUDE' | translate}}</th>
                            <th>{{'LONGITUDE' | translate}}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>{{item.CornerID}}</td>
                            <td>{{item.Latitude}}</td>
                            <td>{{item.Longitude}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapJETankS1">
                    <div class="field col-12 md:col-12">
                      <p-gmap [options]="xenTank1SurveyData?.newGPSjeArray?.options" type="satellite"
                        [overlays]="xenTank1SurveyData?.newGPSjeArray?.overlays"
                        [style]="{'width':'100%','height':'320px'}"></p-gmap>
                    </div>
                  </div>
                </div>

                <div *ngIf="xenTank1SurveyData?.attachements?.length > 0">
                  <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                  <div class="p-fluid p-formgrid grid" style="padding:10px">
                    <div *ngFor="let image of xenTank1SurveyData.attachements; let index = index;" class="field m-3" key="index">
                      <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                        (click)="imageClick(index, xenTank1SurveyData.attachements)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image.DocumentType}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- XEN SURVEY STAGE-1 Content End -->

            
            <!-- attachments pond stage1 starts-->
            <!-- <ng-container *ngIf="t3AttachmentsPondStage1">
              <div class="table">
                <div class="print bold heading-3" style="margin-top:0.5px;">{{'POND_STAGE1_ATTACHMENT_DETAILS' | translate}}</div>
                <div class="p-fluid p-formgrid grid" style="padding:10px">
                  <div *ngFor="let image of t3AttachmentsPondStage1; let index = index;" class="field m-3" key="index">
                    <div class="" *ngIf="image?.IsExist == 1">
                      <img [src]="image?.Attachments" [alt]="image?.DocumentType" style="cursor: pointer"
                        (click)="imageClick1(index, t3AttachmentsPondStage1)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image?.DocumentType + ' ' + image?.Stage}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container> -->
            <!-- attachments pond stage1 ends-->

            <div class="print sec-heading d-flex justify-content-center">{{'Pond/Tank Head Office Subsidy Calculation/Recommendation for Stage 1st Detail' | translate}}</div>
            <!--  CAL STAGE-1 JE Content Start -->
            <ng-container *ngIf="calStage1JE?.IsExist == 1 && calStage1JE?.ActionType == 'CalcStg1_JE'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE1_JE-EW' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage1JE?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage1JE?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage1JE?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage1JE?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1JE?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1JE?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage1JE?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage1JE?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage1JE?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage1JE?.Coverage_Area }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'JE_REMARK_CALC_STAGE1' | translate}}</p>
                      <p>{{ remarksData?.JE_EW_Remarks_CalcStg1 }}</p>
                    </td>
                    <td *ngIf="calStage1JE?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage1JE?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-1 JE Content End -->

            <!--  CAL STAGE-1 DD Content Start -->
            <ng-container *ngIf="calStage1DD?.Exist == 1 && calStage1DD?.ActionType == 'CalcStg1_DD'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE1_DD' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage1DD?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage1DD?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage1DD?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage1DD?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DD?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DD?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DD?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DD?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage1DD?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage1DD?.Coverage_Area }}</p>
                    </td>
                    <td *ngIf="calStage1DD?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage1DD?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-1 DD Content End -->

            <!--  CAL STAGE-1 DA Content Start -->
            <ng-container *ngIf="calStage1DA?.IsExist == 1 && calStage1DA?.ActionType == 'CalcStg1_DA'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE1_DA' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage1DA?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage1DA?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage1DA?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage1DA?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DA?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DA?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DA?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DA?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage1DA?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage1DA?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'DA_REMARK_CALC_STAGE1' | translate}}</p>
                      <p>{{ remarksData?.DARemarks_Stg1 }}</p>
                    </td>
                    <td *ngIf="calStage1DA?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage1DA?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-1 DA Content End -->

            <!--  CAL STAGE-1 DMICADA Content Start -->
            <ng-container *ngIf="calStage1DMICADA?.IsExist == 1 && calStage1DMICADA?.ActionType == 'CalcStg1_DMICADA'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE1_DD-EW' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage1DMICADA?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage1DMICADA?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage1DMICADA?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage1DMICADA?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DMICADA?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DMICADA?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DMICADA?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage1DMICADA?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage1DMICADA?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage1DMICADA?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'DD-EW_REMARK' | translate}}</p>
                      <p>{{ remarksData?.DMICADAReamrks }}</p>
                    </td>
                    <td *ngIf="calStage1DMICADA?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage1DMICADA?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-1 DMICADA Content End -->

            <!--  CAL STAGE-1 ADMIN Content Start -->
            <ng-container *ngIf="calStage1Admin?.IsExist == 1 && calStage1Admin?.ActionType == 'CalcStg1_Admin'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE1_ADMIN' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage1Admin?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage1Admin?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage1Admin?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage1Admin?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1Admin?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage1Admin?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage1Admin?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage1Admin?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage1Admin?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage1Admin?.Coverage_Area }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'ADMIN_REMARK_STAGE1' | translate}}</p>
                      <p>{{ remarksData?.AdminRemarks_Stg1 }}</p>
                    </td> -->
                    <td *ngIf="calStage1Admin?.estimateCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage1Admin?.estimateCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-1 ADMIN Content End -->
          </div>
          

          <div *ngIf="pondS2Exist">
            <div class="print sec-heading d-flex justify-content-center">{{'POND_TANK_STAGE2_FIELD_PHYSICAL_SURVEY_DETAILS' | translate}}</div>
            <!-- JE SURVEY STAGE-2 Content Start -->
            <ng-container *ngIf="surveyStage2JE?.IsExist == 1 && surveyStage2JE?.ActionType == 'SurveyStg2_JE'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SURVEY_STAGE2_JE' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE2' | translate}}</p>
                      <p>{{ surveyStage2JE?.ActualSubsidy_Stage2 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ASSISTANCE_PAID_AT_STAGE2' | translate}}</p>
                      <p>{{ surveyStage2JE?.AssistancePaidAtStage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2JE?.CenterShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2JE?.StateShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.ABY }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.Topup }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ surveyStage1XEN?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ surveyStage1XEN?.NoOfBeneficiary }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'SURVEY_TYPE' | translate}}</p>
                        <p>
                        {{
                          surveyStage2JE?.SurveyType == 0
                          ? 'Field'
                          : surveyStage2JE?.SurveyType == 1
                            ? 'Office'
                            : ''
                        }}
                        </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOTAL_ESTIMATED_COST' | translate}}</p>
                      <p>{{ surveyStage2JE?.TotalEstimatedCost }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOTAL_ESTIMATED_SUBSIDY' | translate}}</p>
                      <p>{{ surveyStage2JE?.TotalEstimatedSubsidy }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TYPE_OF_POND' | translate}}</p>
                      <p>{{ surveyStage2JE?.TypeOfPond }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'UPDATED_AT' | translate}}</p>
                      <p>{{ surveyStage2JE?.Updated_at | date }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                      <p>{{ surveyStage2JE?.bottomBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                      <p>{{ surveyStage2JE?.bottomLength }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ surveyStage2JE?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                      <p>{{ surveyStage2JE?.bottomSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CREATED_AT' | translate}}</p>
                      <p>{{ surveyStage2JE?.created_at | date }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'DEPTH' | translate}}</p>
                      <p>{{ surveyStage2JE?.depth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LAT' | translate}}</p>
                      <p>{{ surveyStage2JE?.tankLat }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LONG' | translate}}</p>
                      <p>{{ surveyStage2JE?.tankLng }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                      <p>{{ surveyStage2JE?.topBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                      <p>{{ surveyStage2JE?.topLength }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_SIZE' | translate}}</p>
                      <p>{{ surveyStage2JE?.topSize }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'JE-EW_REMARK_STAGE2' | translate}}</p>
                      <p>{{ remarksData?.JERemarks_Stg2 }}</p>
                    </td>
                    <td>
                    <td *ngIf="surveyStage2JE?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{surveyStage2JE?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <div>
                <!-- <div class="print border bold sec-heading-subsidy-details"> -->
                <div *ngIf="jeTanks2SurveyData?.newGPSjeArray?.gpsArray?.length > 0">
                  <div class="print border bold">
                    {{'LIST_GPS_COORDINATES' | translate}}
                  </div>
                  <div class="table mx-2 dashboardTable">
                    <!-- <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6> -->
                    <p-table [value]="jeTanks2SurveyData?.newGPSjeArray?.gpsArray" responsiveLayout="scroll">
                      <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CORNER_ID' | translate}}</th>
                            <th>{{'LATITUDE' | translate}}</th>
                            <th>{{'LONGITUDE' | translate}}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>{{item.CornerID}}</td>
                            <td>{{item.Latitude}}</td>
                            <td>{{item.Longitude}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapJETankS1">
                    <div class="field col-12 md:col-12">
                      <p-gmap [options]="jeTanks2SurveyData?.newGPSjeArray?.options" type="satellite"
                        [overlays]="jeTanks2SurveyData?.newGPSjeArray?.overlays"
                        [style]="{'width':'100%','height':'320px'}"></p-gmap>
                    </div>
                  </div>
                </div>

                <div *ngIf="jeTanks2SurveyData?.attachements?.length > 0">
                  <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                  <div class="p-fluid p-formgrid grid" style="padding:10px">
                    <div *ngFor="let image of jeTanks2SurveyData.attachements; let index = index;" class="field m-3" key="index">
                      <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                        (click)="imageClick(index, jeTanks2SurveyData.attachements)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image.DocumentType}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- JE SURVEY STAGE-2 Content End -->

            <!-- SDO SURVEY STAGE-2 Content Start -->
            <!-- <ng-container *ngIf="false"> -->
            <ng-container *ngIf="surveyStage2SDO?.IsExist == 1 && surveyStage2SDO?.ActionType == 'SurveyStg2_SDO'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SURVEY_STAGE2_SDO' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE2' | translate}}</p>
                      <p>{{ surveyStage2SDO?.ActualSubsidy_Stage2 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ASSISTANCE_PAID_AT_STAGE2' | translate}}</p>
                      <p>{{ surveyStage2SDO?.AssistancePaidAtStage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2SDO?.CenterShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2SDO?.StateShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2SDO?.ABY }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2SDO?.Topup }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ surveyStage2SDO?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ surveyStage2SDO?.NoOfBeneficiary }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'SURVEY_TYPE' | translate}}</p>
                      <p>
                        <!-- {{ surveyStage2SDO?.SurveyType }} -->
                        {{
                          surveyStage2JE?.SurveyType == 0
                          ? 'Field'
                          : surveyStage2JE?.SurveyType == 1
                            ? 'Office'
                            : ''
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOTAL_ESTIMATED_COST' | translate}}</p>
                      <p>{{ surveyStage2SDO?.TotalEstimatedCost }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOTAL_ESTIMATED_SUBSIDY' | translate}}</p>
                      <p>{{ surveyStage2SDO?.TotalEstimatedSubsidy }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TYPE_OF_POND' | translate}}</p>
                      <p>{{ surveyStage2SDO?.TypeOfPond }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'UPDATED_AT' | translate}}</p>
                      <p>{{ surveyStage2SDO?.Updated_at | date }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                      <p>{{ surveyStage2SDO?.bottomBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                      <p>{{ surveyStage2SDO?.bottomLength }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ surveyStage2SDO?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                      <p>{{ surveyStage2SDO?.bottomSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CREATED_AT' | translate}}</p>
                      <p>{{ surveyStage2SDO?.created_at | date }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'DEPTH' | translate}}</p>
                      <p>{{ surveyStage2SDO?.depth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LAT' | translate}}</p>
                      <p>{{ surveyStage2SDO?.tankLat }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LONG' | translate}}</p>
                      <p>{{ surveyStage2SDO?.tankLng }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                      <p>{{ surveyStage2SDO?.topBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                      <p>{{ surveyStage2SDO?.topLength }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_SIZE' | translate}}</p>
                      <p>{{ surveyStage2SDO?.topSize }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'SDO_REMARK_STAGE2' | translate}}</p>
                      <p>{{ remarksData?.SDORemarks_Stg2 }}</p>
                    </td>
                    <td>
                    <td *ngIf="surveyStage2SDO?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{surveyStage2SDO?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <div>
                <!-- <div *ngIf="sdoTanks2SurveyData?.newGPSjeArray?.gpsArray?.length > 0"> -->
                <!-- <div class="print border bold sec-heading-subsidy-details"> -->
                <div *ngIf="sdoTanks2SurveyData?.newGPSjeArray?.gpsArray?.length > 0">
                  <div class="print border bold">
                    {{'LIST_GPS_COORDINATES' | translate}}
                  </div>
                  <div class="table mx-2 dashboardTable">
                    <!-- <h6 class="mt-1 mb-0">Table {{ i + 1}}</h6> -->
                    <p-table [value]="sdoTanks2SurveyData?.newGPSjeArray?.gpsArray" responsiveLayout="scroll">
                      <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CORNER_ID' | translate}}</th>
                            <th>{{'LATITUDE' | translate}}</th>
                            <th>{{'LONGITUDE' | translate}}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>{{item.CornerID}}</td>
                            <td>{{item.Latitude}}</td>
                            <td>{{item.Longitude}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapJETankS1">
                    <div class="field col-12 md:col-12">
                      <p-gmap [options]="sdoTanks2SurveyData?.newGPSjeArray?.options" type="satellite"
                        [overlays]="sdoTanks2SurveyData?.newGPSjeArray?.overlays"
                        [style]="{'width':'100%','height':'320px'}"></p-gmap>
                    </div>
                  </div>
                </div>

                <div *ngIf="sdoTanks2SurveyData.attachements.length > 0">
                  <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                  <div class="p-fluid p-formgrid grid" style="padding:10px">
                    <div *ngFor="let image of sdoTanks2SurveyData.attachements; let index = index;" class="field m-3" key="index">
                      <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                        (click)="imageClick(index, sdoTanks2SurveyData.attachements)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image.DocumentType}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- SDO SURVEY STAGE-2 Content End -->

            <!-- XEN SURVEY STAGE-2 Content Start -->
            <ng-container *ngIf="surveyStage2XEN?.IsExist == 1 && surveyStage2XEN?.ActionType == 'SurveyStg2_XEN'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SURVEY_STAGE2_XEN' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE2' | translate}}</p>
                      <p>{{ surveyStage2XEN?.ActualSubsidy_Stage2 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ASSISTANCE_PAID_AT_STAGE2_' | translate}}</p>
                      <p>{{ surveyStage2XEN?.AssistancePaidAtStage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2XEN?.CenterShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage2XEN?.StateShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.ABY }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ surveyStage1XEN?.Topup }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ surveyStage1XEN?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ surveyStage1XEN?.NoOfBeneficiary }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'SURVEY_TYPE' | translate}}</p>
                      <p>
                        <!-- {{ surveyStage2XEN?.SurveyType }} -->
                        {{
                        surveyStage2JE?.SurveyType == 0
                        ? 'Field'
                        : surveyStage2JE?.SurveyType == 1
                          ? 'Office'
                          : ''
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOTAL_ESTIMATED_COST' | translate}}</p>
                      <p>{{ surveyStage2XEN?.TotalEstimatedCost }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOTAL_ESTIMATED_SUBSIDY' | translate}}</p>
                      <p>{{ surveyStage2XEN?.TotalEstimatedSubsidy }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TYPE_OF_POND' | translate}}</p>
                      <p>{{ surveyStage2XEN?.TypeOfPond }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'UPDATED_AT' | translate}}</p>
                      <p>{{ surveyStage2XEN?.Updated_at | date }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_BREADTH' | translate}}</p>
                      <p>{{ surveyStage2XEN?.bottomBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_LENGTH' | translate}}</p>
                      <p>{{ surveyStage2XEN?.bottomLength }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ surveyStage2XEN?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'BOTTOM_SIZE' | translate}}</p>
                      <p>{{ surveyStage2XEN?.bottomSize }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CREATED_AT' | translate}}</p>
                      <p>{{ surveyStage2XEN?.created_at | date }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'DEPTH' | translate}}</p>
                      <p>{{ surveyStage2XEN?.depth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LAT' | translate}}</p>
                      <p>{{ surveyStage2JE?.tankLat }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TANK_LONG' | translate}}</p>
                      <p>{{ surveyStage2XEN?.tankLng }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_BREADTH' | translate}}</p>
                      <p>{{ surveyStage2XEN?.topBreadth }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_LENGTH' | translate}}</p>
                      <p>{{ surveyStage2XEN?.topLength }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_SIZE' | translate}}</p>
                      <p>{{ surveyStage2XEN?.topSize }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'XEN_REMARK_STAGE2' | translate}}</p>
                      <p>{{ remarksData?.XENRemarks_Stg2 }}</p>
                    </td>
                    <td *ngIf="surveyStage2XEN?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{surveyStage2XEN?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- <div *ngIf="xenTanks2SurveyData?.newGPSjeArray?.gpsArray?.length > 0"> -->
              <div>
                <!-- <div class="print border bold sec-heading-subsidy-details"> -->
                <div *ngIf="xenTanks2SurveyData?.newGPSjeArray?.gpsArray?.length > 0">
                  <div class="print border bold">
                    {{'LIST_GPS_COORDINATES' | translate}}
                  </div>
                  <div class="table mx-2 dashboardTable">
                    <p-table [value]="xenTanks2SurveyData?.newGPSjeArray?.gpsArray" responsiveLayout="scroll">
                      <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CORNER_ID' | translate}}</th>
                            <th>{{'LATITUDE' | translate}}</th>
                            <th>{{'LONGITUDE' | translate}}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item let-i="rowIndex">
                        <tr>
                            <td>{{item.CornerID}}</td>
                            <td>{{item.Latitude}}</td>
                            <td>{{item.Longitude}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                    <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapJETankS1">
                    <div class="field col-12 md:col-12">
                      <p-gmap [options]="xenTanks2SurveyData?.newGPSjeArray?.options" type="satellite"
                        [overlays]="xenTanks2SurveyData?.newGPSjeArray?.overlays"
                        [style]="{'width':'100%','height':'320px'}"></p-gmap>
                    </div>
                  </div>
                </div>

                <div *ngIf="xenTanks2SurveyData?.attachements?.length > 0">
                  <div class="print border bold">{{'LIST_IMAGE_PATH' | translate}}</div>
                  <div class="p-fluid p-formgrid grid" style="padding:10px">
                    <div *ngFor="let image of xenTanks2SurveyData.attachements; let index = index;" class="field m-3" key="index">
                      <img [src]="image.ImagePath" alt='image' style="cursor: pointer"
                        (click)="imageClick(index, xenTanks2SurveyData.attachements)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image.DocumentType}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- XEN SURVEY STAGE-2 Content End -->

            <!-- attachments pond stage2 starts-->
            <!-- <ng-container *ngIf="t3AttachmentsPondStage2">
              <div class="table">
                <div class="print bold heading-3" style="margin-top:0.5px;">{{'POND_STAGE2_ATTACHMENT_DETAILS' | translate}}</div>
                <div class="p-fluid p-formgrid grid" style="padding:10px">
                  <div *ngFor="let image of t3AttachmentsPondStage2; let index = index;" class="field m-3" key="index">
                    <div class="" *ngIf="image?.IsExist == 1">
                      <img [src]="image?.Attachments" [alt]="image?.DocumentType" style="cursor: pointer"
                        (click)="imageClick1(index, t3AttachmentsPondStage2)"
                        style="max-width: 300px; max-height: 300px;" />
                      <div class="flex flex-wrap justify-content-center">
                        <div>{{image?.DocumentType + ' ' + image?.Stage}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container> -->
            <!-- attachments pond stage2 ends-->

            <div class="print sec-heading d-flex justify-content-center">{{'Pond/Tank Head Office Subsidy Calculation/Recommendation for Stage 2nd Detail' | translate}}</div>
            <!--  CAL STAGE-2 JE Content Start -->
            <ng-container *ngIf="calStage2JE?.IsExist == 1 && calStage2JE?.ActionType == 'CalcStg2_JE'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE2_JE-EW' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage2JE?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage2JE?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage2JE?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage2JE?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2JE?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2JE?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage2JE?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage2JE?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage2JE?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage2JE?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'JE_REMARK_CALC_STAGE2' | translate}}</p>
                      <p>{{ remarksData?.JERemarks_CalcStg2 }}</p>
                    </td>
                    <td *ngIf="calStage2JE?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage2JE?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-2 JE Content End -->

            <!--  CAL STAGE-2 DD Content Start -->
            <ng-container *ngIf="calStage2DD?.IsExist == 1 && calStage2DD?.ActionType == 'CalcStg2_DD'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE2_DD' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage2DD?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage2DD?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage2DD?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage2DD?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DD?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DD?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DD?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DD?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage2DD?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage2DD?.Coverage_Area }}</p>
                    </td>
                    <td *ngIf="calStage2DD?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage2DD?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-2 DD Content ENd -->

            <!--  CAL STAGE-2 DA Content Start -->
            <ng-container *ngIf="calStage2DA?.IsExist == 1 && calStage2DA?.ActionType == 'CalcStg2_DA'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE2_DA' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage2DA?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage2DA?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage2DA?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage2DA?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DA?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DA?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DA?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DA?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage2DA?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage2DA?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'DA_REMARK_CALC_STAGE2' | translate}}</p>
                      <p>{{ remarksData?.DERemarks_CalcStg2 }}</p>
                    </td>
                    <td *ngIf="calStage2DA?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage2DA?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-2 DA Content End -->

            <!--  CAL STAGE-2 DMICADA Content Start -->
            <ng-container *ngIf="calStage2DMICADA?.IsExist == 1 && calStage2DMICADA?.ActionType == 'CalcStg2_DMICADA'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE2_DD-EW' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage2DMICADA?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage2DMICADA?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage2DMICADA?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage2DMICADA?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DMICADA?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DMICADA?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DMICADA?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage2DMICADA?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage2DMICADA?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage2DMICADA?.Coverage_Area }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'DD-EW_REMARK_STAGE2' | translate}}</p>
                      <p>{{ remarksData?.DMICADAReamrks_Stg1 }}</p>
                    </td>
                    <td *ngIf="calStage2DMICADA?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage2DMICADA?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-2 DMICADA Content End -->

            <!--  CAL STAGE-2 ADMIN Content Start -->
            <ng-container *ngIf="calStage2Admin?.IsExist == 1 && calStage2Admin?.ActionType == 'CalcStg2_Admin'">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'CAL_STAGE2_ADMIN' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'USER_ID' | translate}}</p>
                      <p>{{ calStage2Admin?.UserID }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1' | translate}}</p>
                      <p>{{ calStage2Admin?.ActualSubsidy_Stage1 }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ESTIMATE_COST' | translate}}</p>
                      <p>{{ calStage2Admin?.estimateCost }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'APPLICANT_TYPE' | translate}}</p>
                      <p>{{ calStage2Admin?.Applicant_type }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2Admin?.CenterShare_Amount }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ calStage2Admin?.StateShare_Amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ calStage2Admin?.ABY }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ calStage2Admin?.Topup }}</p>
                    </td> 
                    <td>
                      <p class="bold">{{'NO_OF_BENEFICIARY' | translate}}</p>
                      <p>{{ calStage2Admin?.NoOfBeneficiary }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'COVERAGE_AREA' | translate}}</p>
                      <p>{{ calStage2Admin?.Coverage_Area }}</p>
                    </td>
                    <td *ngIf="calStage2Admin?.MeasurementCopy">
                      <p class="bold">{{'ESTIMATE_COPY' | translate}}</p>
                      <p><a href="{{calStage2Admin?.MeasurementCopy}}" target="_blank">{{'VIEW_DOC' | translate}}</a>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!--  CAL STAGE-2 ADMIN Content End -->
          </div>

          <!-- MI Installation details start -->
          <ng-container *ngIf="t3VendorDetails?.ActionType == 'PhyCalcDetails' && t3VendorDetails?.IsExist == 1">
            <div class="print bold heading-3" style="margin-top:0.5px;">{{'MI_INSTALLATION_DETAILS' | translate}}</div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'VENDOR_NAME' | translate}}</p>
                    <p>{{ t3VendorDetails?.VendorName }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'MI_AREA_IN_ACRE' | translate}}</p>
                    <p>{{ t3VendorDetails?.MIArea }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'MAX_SUBSIDY_AMOUNT' | translate}}</p>
                    <p>{{ t3VendorDetails?.Subsidy }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
          <!-- MI Installation details end -->

          <!-- attachments starts-->
          <ng-container *ngIf="t3Attachments[0]?.IsExist == 1">
            <div class="table">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'MI_ATTACHMENT_DETAILS' | translate}}</div>
              <div class="p-fluid p-formgrid grid" style="padding:10px">
                <div *ngFor="let image of t3Attachments; let index = index;" class="field m-3" key="index">
                  <div class="" *ngIf="image?.IsExist == 1">
                    <img [src]="image?.Attachments" [alt]="image?.DocumentType" style="cursor: pointer"
                      (click)="imageClick1(index, t3Attachments)" style="max-width: 300px; max-height: 300px;" />
                    <div class="flex flex-wrap justify-content-center">
                      <div>{{image?.DocumentType + ' ' + image?.Program_Name}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- attachments ends-->
        </div>
      </div>
      <!-- Tank-Stage-3-end -->


      <!-- Subsidy Details Start -->
      <div class="tank-stage1-form border my-4" *ngIf="showSubsidyDetails">
        <div class="mt-1 form-name">
          <p> {{'SUBSIDY_DETAILS' | translate}} </p>
        </div>

        <div class="consent-form">
          <div>
            <div class="print sec-heading-subsidy-details d-flex justify-content-center">{{'SUBSIDY_DISBURSMENT_DETAILS' | translate}}</div>
            <!-- FarmerShareToVendor Content Start -->
            <ng-container *ngIf="FSTVDetails?.IsExist == 1">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'PAYMENT_TO_VENDOR(15%_FARMER_SHARE)' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'FINANCIAL_YEAR' | translate}}</p>
                      <p>{{ FSTVDetails?.Fin_Year }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'FILE_NO' | translate}}</p>
                      <p>{{ FSTVDetails?.FileNo }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'PROGRAM_NAME' | translate}}</p>
                      <p>{{ FSTVDetails?.Program_Name }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'Payment to Vendor (15% farmer share)' | translate}}</p>
                      <p>{{ FSTVDetails?.FarmerShare_to_Vendor | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACCOUNT_BRANCH_REMARKS' | translate}}</p>
                      <p>{{ FSTVDetails?.Remarks }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'PAYMENT_STATUS' | translate}}</p>
                      <p>{{ FSTVDetails?.Status }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'PAYMENT_DATE' | translate}}</p>
                      <p>{{ FSTVDetails?.PFMSPaymentDate | date:'mediumDate' }}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!-- FarmerShareToVendor Content End -->

            <!-- SubsidyToVendor Content Start -->
            <ng-container *ngIf="STVDetails?.IsExist == 1">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'PAYMENT_TO_VENDOR(85%_OF_TOTAL_COST)' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'FINANCIAL_YEAR' | translate}}</p>
                      <p>{{ STVDetails?.Fin_Year }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'FILE_NO' | translate}}</p>
                      <p>{{ STVDetails?.FileNo }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'PROGRAM_NAME' | translate}}</p>
                      <p>{{ STVDetails?.Program_Name }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'Payment to Vendor (85% of total Cost)' | translate}}</p>
                      <p>{{ STVDetails?.Subsidy_to_Vendor | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ STVDetails?.State_share_amt | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ STVDetails?.Centre_share_amt | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ STVDetails?.TopUp | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACCOUNT_BRANCH_REMARKS' | translate}}</p>
                      <p>{{ STVDetails?.Remarks }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'PAYMENT_STATUS' | translate}}</p>
                      <p>{{ STVDetails?.Status == 'S' ? 'Successfull' : PTVDetails?.Status == 'P' ? 'Pending' : PTVDetails?.Status }}</p>
                    </td> -->
                    <td>
                      <p class="bold">{{'PAYMENT_DATE' | translate}}</p>
                      <p>{{ STVDetails?.PFMSPaymentDate | date:'mediumDate'}}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!-- SubsidyToVendor Content End -->

            <!-- SubsidyToFarmer Content Start -->
            <ng-container *ngIf="STFDetails?.IsExist == 1">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SUBSIDY_TO_FARMER' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'FINANCIAL_YEAR' | translate}}</p>
                      <p>{{ STFDetails?.Fin_Year }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'FILE_NO' | translate}}</p>
                      <p>{{ STFDetails?.FileNo }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'PROGRAM_NAME' | translate}}</p>
                      <p>{{ STFDetails?.Program_Name }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'Payment to Farmer' | translate}}</p>
                      <p>{{ STFDetails?.Subsidy_Amt_Farmer | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ STFDetails?.State_share_amt | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ STFDetails?.Centre_share_amt | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ STFDetails?.TopUp | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACCOUNT_BRANCH_REMARKS' | translate}}</p>
                      <p>{{ STFDetails?.Remarks }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'PAYMENT_STATUS' | translate}}</p>
                      <p>{{ STFDetails?.Status == 'S' ? 'Successfull' : PTVDetails?.Status == 'P' ? 'Pending' : PTVDetails?.Status }}</p>
                    </td> -->
                    <td>
                      <p class="bold">{{'PAYMENT_DATE' | translate}}</p>
                      <p>{{ STFDetails?.PFMSPaymentDate | date:'mediumDate'}}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!-- SubsidyToFarmer Content End -->

            <!-- RefundToFarmer Content Start -->
            <ng-container *ngIf="RTFDetails?.IsExist == 1">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'REFUND_TO_FARMER(ACCESS_FARMER_SHARE_DEPOSITED)' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'FINANCIAL_YEAR' | translate}}</p>
                      <p>{{ RTFDetails?.Fin_Year }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'FILE_NO' | translate}}</p>
                      <p>{{ RTFDetails?.FileNo }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'PROGRAM_NAME' | translate}}</p>
                      <p>{{ RTFDetails?.Program_Name }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'Payment to Vendor (85% of total Cost)' | translate}}</p>
                      <p>{{ RTFDetails?.Subsidy_to_Vendor | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ RTFDetails?.StateShare_Amount | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ RTFDetails?.CenterShare_Amount | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ACCOUNT_BRANCH_REMARKS' | translate}}</p>
                      <p>{{ RTFDetails?.Remarks }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'PAYMENT_STATUS' | translate}}</p>
                      <p>{{ RTFDetails?.Status == 'S' ? 'Successfull' : PTVDetails?.Status == 'P' ? 'Pending' : PTVDetails?.Status }}</p>
                    </td> -->
                    <td>
                      <p class="bold">{{'PAYMENT_DATE' | translate}}</p>
                      <p>{{ RTFDetails?.PFMSPaymentDate | date:'mediumDate'}}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!-- RefundToFarmer Content End -->

            <div class="print sec-heading-subsidy-details d-flex justify-content-center">{{'SUBSIDY_DISBURSMENT_DETAILS_FOR_POND' | translate}}</div>

            <!-- PondStage1 Content Start -->
            <ng-container *ngIf="PondStage1?.IsExist == 1">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SUBSIDY_TO_FARMER_FOR_TANK/POND_STAGE1_EARTH_WORK' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'FINANCIAL_YEAR' | translate}}</p>
                      <p>{{ PondStage1?.Fin_Year }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'FILE_NO' | translate}}</p>
                      <p>{{ PondStage1?.FileNo }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'SUBSIDY_AMOUNT' | translate}}</p>
                      <p>{{ PondStage1?.Subsidy_Amt | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ PondStage1?.StateShare_Amount | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ PondStage1?.CenterShare_Amount | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ PondStage1?.TopUp | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ PondStage1?.ABY | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACCOUNT_BRANCH_REMARKS' | translate}}</p>
                      <p>{{ PondStage1?.Remarks }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'PAYMENT_STATUS' | translate}}</p>
                      <p>{{ PondStage1?.Status == 'S' ? 'Successfull' : PTVDetails?.Status == 'P' ? 'Pending' : PTVDetails?.Status }}</p>
                    </td> -->
                    <td>
                      <p class="bold">{{'PAYMENT_DATE' | translate}}</p>
                      <p>{{ PondStage1?.PFMSPaymentDate }}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!-- PondStage1 Content End -->

            <!-- PondStage2 Content Start -->
            <ng-container *ngIf="PondStage2?.IsExist == 1">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SUBSIDY_TO_FARMER_FOR_TANK/POND_STAGE2_COMPLETE_WORK' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'FINANCIAL_YEAR' | translate}}</p>
                      <p>{{ PondStage2?.Fin_Year }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'FILE_NO' | translate}}</p>
                      <p>{{ PondStage2?.FileNo }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'SUBSIDY_AMOUNT' | translate}}</p>
                      <p>{{ PondStage2?.Subsidy_Amt | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ PondStage2?.StateShare_Amount | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ PondStage2?.CenterShare_Amount | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ PondStage2?.TopUp | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ PondStage2?.ABY | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACCOUNT_BRANCH_REMARKS' | translate}}</p>
                      <p>{{ PondStage2?.Remarks }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'PAYMENT_STATUS' | translate}}</p>
                      <p>{{ PondStage2?.Status == 'S' ? 'Successfull' : PTVDetails?.Status == 'P' ? 'Pending' : PTVDetails?.Status }}</p>
                    </td> -->
                    <td>
                      <p class="bold">{{'PAYMENT_DATE' | translate}}</p>
                      <p>{{ PondStage2?.PFMSPaymentDate }}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!-- PondStage2 Content End -->

            <!-- PondStage3 Content Start -->
            <ng-container *ngIf="PondStage3?.IsExist == 1">
              <div class="print bold heading-3" style="margin-top:0.5px;">{{'SUBSIDY_TO_FARMER_FOR_TANK/POND_STAGE3_PENDING_AMOUNT' | translate}}</div>
              <div class="table">
                <table class="border">
                  <tr>
                    <td>
                      <p class="bold">{{'FINANCIAL_YEAR' | translate}}</p>
                      <p>{{ PondStage3?.Fin_Year }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'FILE_NO' | translate}}</p>
                      <p>{{ PondStage3?.FileNo }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'SUBSIDY_AMOUNT' | translate}}</p>
                      <p>{{ PondStage3?.Subsidy_Amt | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'STATE_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ PondStage3?.StateShare_Amount | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'CENTER_SHARE_AMOUNT' | translate}}</p>
                      <p>{{ PondStage3?.CenterShare_Amount | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'TOP_UP_AMOUNT' | translate}}</p>
                      <p>{{ PondStage3?.TopUp | currency: 'INR' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="bold">{{'ABY_AMOUNT' | translate}}</p>
                      <p>{{ PondStage3?.ABY | currency: 'INR' }}</p>
                    </td>
                    <td>
                      <p class="bold">{{'ACCOUNT_BRANCH_REMARKS' | translate}}</p>
                      <p>{{ PondStage3?.Remarks }}</p>
                    </td>
                    <!-- <td>
                      <p class="bold">{{'PAYMENT_STATUS' | translate}}</p>
                      <p>{{ PondStage3?.Status == 'S' ? 'Successfull' : PTVDetails?.Status == 'P' ? 'Pending' : PTVDetails?.Status }}</p>
                    </td> -->
                    <td>
                      <p class="bold">{{'PAYMENT_DATE' | translate}}</p>
                      <p>{{ PondStage3?.PFMSPaymentDate }}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </ng-container>
            <!-- PondStage3 Content End -->
          </div>
        </div>
      </div>
      <!-- Subsidy Details End -->

    </div>




    <!-- <app-vendor-mi-estimation-consent-form></app-vendor-mi-estimation-consent-form> -->

    <div class="flex justify-content-around mb-2">
      <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT' | translate}}"
        (click)="onPrint('printableArea')"></button>
    </div>

    <div class="card mt-2" reflow="true">
      <div class="grid p-fluid">
        <div class="field col-12">
          <label htmlFor="state" class="bold">{{'CURRENT_APPLICATION_SUBSIDY_DEPARTMENT' | translate}}</label>
          <p-table [value]="farmerPreviousSubsidies" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'APP_ID' | translate}}</th>
                <th>{{'FARMER_NAME' | translate}}</th>
                <th>{{'DEPARTMENT' | translate}}</th>
                <th>{{'AREA' | translate}}</th>
                <th>{{'SUBSIDY_YEAR' | translate}}</th>
                <th>{{'AADHAR_NUMBER' | translate}}</th>
                <th>{{'SYSTEM' | translate}}</th>
                <th>{{'LAND_DETAILS' | translate}}</th>
                <th>{{'DIFF_YEAR' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-subsidy>
              <tr>
                <td>{{ subsidy.AppId }}</td>
                <td>{{ subsidy.FarmerName }}</td>
                <td>{{ subsidy.Department }}</td>
                <td>{{ subsidy.Area | number: "1.2-2" }}</td>
                <td>{{ subsidy.SubsidyYear }}</td>
                <td>{{ subsidy.AadharNo }}</td>
                <td>{{ subsidy.System }}</td>
                <td>{{ subsidy.LandDetail }}</td>
                <td>{{ subsidy.DiffYear }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10">{{'NO_RECORDS_TO_SHOW' | translate}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <!-- <h5><b>Appication Status</b> : {{applicationStatus}}</h5> -->
    </div>
    <!-- <div class="card" reflow="true" *ngIf="!farmerData2"> -->
    <div class="card" reflow="true">
       <app-application-work-flow-diag [applicationId]="applicationDetails?.APP_ID"[showLegend]="true"></app-application-work-flow-diag> <!--STEPPER application status-->
      <div *ngIf="viewWorkFlowAllStatus">
        <app-work-flow-all-status [applicationId]="applicationDetails?.APP_ID"></app-work-flow-all-status>
      </div>

      <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
        class="p-button-secondary" (click)="workFlowAllStatus()"></button>
    </div>

    <div class="mt-2" style="display: flex; justify-content: center;">
      <button pButton pRipple label="Back" icon="pi pi-backward" class="p-button-primary" (click)="onClickBack()"></button>
  </div>
  </div>

  <p-dialog [(visible)]="displayFileDialog" [modal]="true" [style]="{ margin: '3rem' }" [maximizable]="true"
    [draggable]="false" [resizable]="true" (onHide)="onCloseDialog()">
    <ng-template pTemplate="header">
      <div>
        <button pButton pRipple icon="pi pi-search-plus" class="p-button-text" (click)="transformImage(null, 'zoom-in')"
          [disabled]="numberEquals(scalingAmount, 1)"></button><br />
        <button pButton pRipple icon="pi pi-search-minus" class="p-button-text"
          (click)="transformImage(null, 'zoom-out')" [disabled]="numberEquals(scalingAmount, '0.1')"></button>
      </div>
    </ng-template>
    <!-- <div class="flex flex-wrap align-items-center justify-content-center">
      <img [src]="rotatableFilePath" id="myname" #myname
        style="object-fit: contain; z-index: 0; max-width: 700px; max-height: 700px; aspect-ratio: 1;">
    </div> -->
    <embed [src]="getSafeUrl()" style="width: 100%; height: 100%" id="myname" #myname />

    <ng-template pTemplate="footer">
      <div class="flex flex-wrap align-items-center justify-content-center">
        <button pButton pRipple label="{{'ROTATE_LEFT' | translate}}" icon="pi pi-angle-left" class="p-button-success"
          (click)="transformImage('left', null)"></button>
        <button pButton pRipple label="{{'ROTATE_RIGHT' | translate}}" icon="pi pi-angle-right" class="p-button-success"
          (click)="transformImage('right', null)"></button>
      </div>
    </ng-template>
  </p-dialog>
  

  <!-- dialog box for showing land owner details -->
  <p-dialog header="{{ 'LAND_OWNER_DETAILS' | translate }}" [(visible)]="displayLandOwnerDialog" [modal]="true" [style]="{width: '95%',height:'auto'}"
    [maximizable]="true" [draggable]="true" [resizable]="true" (onHide)="onCloseLandOwnerDialog()">

    <div class="card land-info-details">
        <div class="field md:col-3 col-12">
            <p>{{'FARMER_ID'| translate}}: <label>{{ selLandForOwnerdetails?.farmerId }}</label></p>
        </div>
        <div class="field md:col-3 col-12">
          <p>{{'VILLAGE'| translate}}: <label>{{ selLandForOwnerdetails?.Village }}</label></p>
        </div>
        <div class="field md:col-3 col-12">
            <p>{{'KHEWAT'| translate}}: <label>{{ selLandForOwnerdetails?.Khewat }}</label></p>
        </div>
        <div class="field md:col-3 col-12">
            <p>{{'OWNER_NAME'| translate}}: <label>{{ selLandForOwnerdetails?.OwnerName }}</label></p>
        </div>
        <div class="field md:col-3 col-12">
            <p>{{'BHAG'| translate}}: <label>{{ selLandForOwnerdetails?.Bhag }}</label></p>
        </div>
        <div class="field md:col-3 col-12">
            <p>{{'KHEWAT_AREA'| translate}}: <label>{{ selLandForOwnerdetails?.KhewatArea }}</label></p>
        </div>
        <div class="field md:col-3 col-12">
            <p>{{'OWNER_HISSA_IN_ACRES'| translate}}: <label>{{ selLandForOwnerdetails?.OwnerHissa }}</label></p>
        </div>
        <div class="field md:col-3 col-12">
            <p>{{'APPLIED_AREA'| translate}}: <label>{{ selLandForOwnerdetails?.totalArea }}</label></p>
        </div>

        <div class="field md:col-3 col-12">
            <p>{{'FINANCIAL_YEAR'| translate}}: <label>{{ selLandForOwnerdetails?.Year }}</label></p>
        </div>
        
        <div class="field md:col-3 col-12">
            <p>{{'MORABBA_NUMBER'| translate}}: <label>{{ selLandForOwnerdetails?.morabbaNo }}</label></p>
        </div>

        <div class="field md:col-3 col-12">
            <p>{{'KILLA_NO'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selLandForOwnerdetails?.killaNo }}</label></p>
        </div>
    </div>

    <div class="find-new-khewat-box">
      <div class="d-flex justify-content-between mx-2">
        <label>{{ "FETCH_UPDATED_KHEWAT" | translate }}<label (click)="onClickGetNewKhewat()" class="mx-3 clickable">Click here</label> </label>
      </div>
    </div>

    <div class="input-container">
      <input type="text" pInputText placeholder="Enter Kewat No" [(ngModel)]="kewatNo" />
      <button pButton pRipple type="button" type="submit" label="{{'Get Owner Details' | translate}}"
                class="p-button-success mr-2 mb-2" (click)="submitKewatNo()"></button>
      <!-- <button (click)="submitKewatNo()">Submit</button> -->
    </div>
    
    <p-progressBar mode="indeterminate" *ngIf="isLandOwnerDetFetching"></p-progressBar>
    <div *ngIf="isLandOwnerDetFetching" class="loading-text">
      <p>{{ loadingText }}</p>
    </div>
    <ng-template pTemplate="content">
      <div *ngIf="landOwnerDetails?.length > 0 && !isLandOwnerDetFetching" class="p-fluid p-formgrid justify-content-center">
        <p-table #landOwnerDataTable [value]="landOwnerDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'Owner_Name',
            'Bhag',
            'Khewat',
            'khewat_area',
            'owner_hissa',
            'TotalArea',
            'Year',
            ]" [rowHover]="true" dataKey="uiqueId"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="grid p-fluid mt-2 justify-content-between">
              <!-- Left side -->
              <div class="field col-12 md:col-6">
                <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{
                  'Fetched Land Owner Details from Jamabandi Portal' }}</p>
              </div>
              <!-- Middle section for buttons -->
              <div class="field col-0 md:col-0">
              </div>
              <!-- Right side for search -->
              <div class="field col-12 md:col-6 align-items-center justify-content-end">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text"
                    (input)="landOwnerDataTable.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="{{'SEARCH'| translate}}" />
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{'S.No'| translate}}</th>
              <th>{{'KHEWAT'| translate}}</th>
              <th>{{'OWNER_NAME'| translate}}</th>
              <th>{{'BHAG'| translate}}</th>
              <th>{{'KHEWAT_AREA'| translate}}</th>
              <th>{{'OWNER_HISSA_IN_ACRES'| translate}}</th>
              <th>{{'TOTAL_APPLIED_AREA_IN_ACRES'| translate}}</th>
              <th>{{'FARMER_APPLIED_AREA_IN_ACRES'| translate}}</th>
              <th>{{'YEAR'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{product?.Khewat}}</td>
              <td>{{product?.Owner_Name}}</td>
              <td>{{product?.Bhag}}</td>
              <td>{{product?.khewat_area}}</td>
              <td>{{product?.owner_hissa | number:'0.3-3'}}</td>
              <td>{{product?.TotalArea | number:'0.3-3'}}</td>
              <td>{{product?.TotalAreaFarmer | number:'0.3-3'}}</td>
              <td>{{product?.Year}}</td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="landDetailedInfo.length > 0">
          <p-table #landOwnerDetailsDataTable [value]="landDetailedInfo" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
            'khatoni',
            'khewat',
            'killa',
            'must',
            'knl',
            'mrl',
            'period',
            ]" [rowHover]="true" dataKey="killa" 
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" responsiveLayout="scroll">
            <ng-template pTemplate="caption">
              <div class="grid p-fluid mt-2 justify-content-between">
                <!-- Left side -->
                <div class="field col-12 md:col-6">
                  <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">
                    {{
                    'Fetched Land Details from Jamabandi Portal' }}</p>
                </div>
                <!-- Middle section for buttons -->
                <div class="field col-0 md:col-0">
  
                </div>
                <!-- Right side for search -->
                <div class="field col-12 md:col-6 align-items-center justify-content-end">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                      (input)="landOwnerDetailsDataTable.filterGlobal($any($event.target).value, 'contains')"
                      placeholder="{{'SEARCH'| translate}}" />
                  </span>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>{{'S.No'| translate}}</th>
                <th>{{'KHATONI'| translate}}</th>
                <th>{{'KHEWAT'| translate}}</th>
                <th>{{'MORABBA_NUMBER'| translate}}</th>
                <th>{{'KILLA_NO'| translate}}</th>
                <th>{{'KANALS'| translate}}</th>
                <th>{{'MARLAS'| translate}}</th>
                <th>{{'YEAR'| translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{product?.khatoni}}</td>
                <td>{{product?.khewat}}</td>
                <td>{{product?.must}}</td>
                <td>{{product?.killa}}</td>
                <td>{{product?.knl}}</td>
                <td>{{product?.mrl}}</td>
                <td>{{product?.period}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="update-land-details my-3 px-5" *ngIf="landDetailedInfo.length > 0 && (selLandForOwnerdetails?.Khewat != landDetailedInfo[0]?.khewat)">
          <button pButton pRipple type="button" label="{{'UPDATE_LAND_KHEWAT' | translate}}" class="p-button-warning"
            (click)="onClickUpdateLandKhewat()"></button>

        </div>
      </div>
      
      <div *ngIf="landOwnerDetails.length == 0 && !isLandOwnerDetFetching" class="p-fluid p-formgrid justify-content-center">
        <div class="field md:col-12 col-12">
          <label [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold'}">{{ landOwnerDetailsErrorMsg }}</label>
        </div>
      </div>

      <button pButton pRipple type="button" label="{{'CLOSE'| translate}}" class="p-button-secondary" style="float: right;"
        (click)="onCloseLandOwnerDialog()"></button>

    </ng-template>
  </p-dialog>


  <p-dialog header="{{ 'Find Khewat by Khasra' | translate }}" [(visible)]="displayFindKhewatDialog" [modal]="true" [style]="{width: '60%',height:'auto'}"
    [maximizable]="true" [draggable]="true" [resizable]="true" (onHide)="onCloseFindKhewat()">
    <div class="card new-khewat-detail p-fluid p-formgrid justify-content-center">
      <div class="input-container">
        <input type="text" pInputText placeholder="Enter Morabba No" [(ngModel)]="morabbaNoForNewKhewat" />
        <input type="text" pInputText placeholder="Enter kill No" [(ngModel)]="killaNoForNewKhewat" />
        <button pButton pRipple type="button" type="submit" label="{{'Get New Khewat' | translate}}"
                  class="p-button-success mr-2 mb-2" (click)="submitKhasraNo()"></button>
      </div>
    </div>

    <p-progressBar mode="indeterminate" *ngIf="isNewKhewatNoFetching"></p-progressBar>
    <div *ngIf="isNewKhewatNoFetching" class="loading-text">
      <p>{{ loadingTextNewKhewat }}</p>
    </div>
    
    <div class="mt-2 new-khewat-no-box" *ngIf="newKhewatNo?.length > 0">
      <label>Fetched Updated Khewat: <label class="new-khewat-no">{{ newKhewatNo[0]?.khewat }}</label></label>
    </div>
  </p-dialog>

</div>
<div *ngIf="!applicationDetails?.APP_ID">
  <div *ngIf="!isAppdetailsLoading" class="card" reflow="true">{{'APPLICATION_NOT_FOUND' | translate}}</div>

  <div *ngIf="isAppdetailsLoading">
    <p-progressBar mode="indeterminate" *ngIf="isAppdetailsLoading"></p-progressBar>
    <div class="loading-text">
      <p>{{ 'Loading Application Data...' }}</p>
    </div>
  </div>
</div>

<p-galleria [value]="imgVal" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
  [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
  [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
  <ng-template pTemplate="item" let-item>
    <img [src]="item.ImagePath" style="width: 100%; display: block;" />
  </ng-template>
  <!-- <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.ImagePath" style="display: block;" />
        </div>
    </ng-template> -->
</p-galleria>

<p-galleria [value]="imgVal" [(visible)]="displayCustom1" [(activeIndex)]="activeIndex"
  [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
  [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
  <ng-template pTemplate="item" let-item>
    <img [src]="item.Attachments" style="width: 100%; display: block;" />
  </ng-template>
</p-galleria>